// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-08T20:10:21.856Z
// Property: Park Paloma (ID: 6767906449166801)
// Collections: 47 amenities, 2 floorplans (live), 18 photos, 76 POIs, 12 reviews, 3 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166801",
  "property_external_id": "qlxsr7x",
  "property_zillow_url": "https://www.zillow.com/apartments/phoenix-az/park-paloma/5XhySR/",
  "property_apartments_url": "https://www.apartments.com/park-paloma-phoenix-az/qlxsr7x/",
  "property_google_business_url": "https://www.google.com/maps/place/Park+Paloma+Apartments/@33.4809691,-111.98285,15z/data=!4m6!3m5!1s0x872b0c38bc86221b:0xed32f0f7160dbfd4!8m2!3d33.4812189!4d-111.98285!16s%2Fg%2F1tdwfd2g?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "41632009012",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "234PAP",
  "property_status": null,
  "property_slug": "park-paloma",
  "property_name": "Park Paloma",
  "property_website_url": "https://www.parkpalomaapartments.com/",
  "property_domain": "https://www.parkpalomaapartments.com/",
  "property_address": "2930 North 46th Street",
  "property_full_address": "2930 N 46th St, Phoenix, AZ 85018",
  "property_address_1": "2930 N 46th St",
  "property_address_2": null,
  "property_address_city": "Phoenix",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85018",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Camelback East Village",
  "property_address_latitude": "33.4812346",
  "property_address_longitude": "-111.9829897",
  "property_email": null,
  "property_phone": "(888) 219-7370",
  "property_call_tracking_phone": "888-521-5369",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Park Paloma, where elegance meets comfort in the heart of Phoenix. Choose from our thoughtfully designed one and two-bedroom floor plans, complete with gourmet kitchens and spacious walk-in closets. Enjoy exclusive amenities like a relaxing spa, vibrant clubhouse, and pet-friendly bark park. Your ideal lifestyle awaits!",
  "property_long_description": "Welcome to Park Paloma, your oasis in the heart of Phoenix, AZ! Our vibrant apartment community offers a range of thoughtfully designed floor plans, including spacious one and two-bedroom options, tailored to suit your lifestyle needs. Experience modern living with fully renovated homes featuring elegant quartz countertops, energy-efficient stainless steel appliances, and rich wood-style flooring.\n\nAt Park Paloma, your comfort and convenience are paramount. Enjoy peace of mind with controlled access, a property manager on-site, and 24/7 emergency maintenance. Our extensive amenities ensure there's something for everyone. Dive into relaxation at our sparkling pool or unwind in the spa, and stay active in our well-equipped fitness center. Our clubhouse is perfect for social gatherings, while the planned social activities foster a sense of community.\n\nFor pet lovers, enjoy our bark park and pet play area, ensuring your furry friends have the space to roam and play. With online services for rent payment and maintenance requests, managing your home has never been easier!\n\nSituated near public transportation, our community offers easy access to everything Phoenix has to offer. Embrace the outdoors with lovely picnic areas and gas barbeque grills, perfect for weekend gatherings. \n\nFind your new home today at Park Paloma! Browse our availability or schedule a tour to discover why our residents love calling this community home. Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-f921-7517-8cc7-0d3e98da5710.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
    "public_id": "019d02d3-f921-7517-8cc7-0d3e98da5710",
    "storage_key": "property/6767906449166801/019d02d3-f921-7517-8cc7-0d3e98da5710.webp",
    "width": 1280,
    "height": 719
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166801/019f66a8-1886-750b-8777-e13d314dd2c1.m4v",
  "property_featured_video_media": {
    "public_id": "019f66a8-1886-750b-8777-e13d314dd2c1",
    "storage_key": "property/6767906449166801/019f66a8-1886-750b-8777-e13d314dd2c1.m4v",
    "thumbnail_key": "property/6767906449166801/019f66a8-1886-750b-8777-e13d314dd2c1_thumb.webp",
    "size_bytes": 9506302,
    "classification": "Community",
    "title": "Park Paloma Hero Video",
    "description": "Imported from Duda homepage hero background video"
  },
  "property_total_units": "60",
  "property_year_built": "1973",
  "property_year_renovated": null,
  "property_walk_score": "80",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95",
  "property_admin_fee": "250",
  "property_application_fee": "65",
  "property_fees_deposit_info": "Security Deposit\n$250 to 1 Month's Rent\n(refundable)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "45",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of 2 pets per unit. Breed and weight restrictions apply.",
  "property_pet_policy_description": "We welcome cats and dogs. Non‑refundable pet fee: $300 for one pet. Monthly pet rent: $45 for one pet, $80 for two pets. Maximum of 2 pets per unit. Breed and weight restrictions apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://parkpaloma.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcparkpaloma",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-d490-76d3-bad5-c23e9caa6984.webp",
  "property_primary_logo_media": {
    "alt_text": "Park Paloma logo",
    "public_id": "019d02d0-d490-76d3-bad5-c23e9caa6984",
    "storage_key": "property/6767906449166801/019d02d0-d490-76d3-bad5-c23e9caa6984.webp",
    "width": 354,
    "height": 95
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d4-71d9-707f-84d3-e27e7d0ab7c1.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Park Paloma logo",
    "public_id": "019d02d4-71d9-707f-84d3-e27e7d0ab7c1",
    "storage_key": "property/6767906449166801/019d02d4-71d9-707f-84d3-e27e7d0ab7c1.webp",
    "width": 354,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d4-7f82-77a2-88b4-f880c3276d27.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Park Paloma logo",
    "public_id": "019d02d4-7f82-77a2-88b4-f880c3276d27",
    "storage_key": "property/6767906449166801/019d02d4-7f82-77a2-88b4-f880c3276d27.webp",
    "width": 354,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#38505a",
  "property_secondary_color": "#9b7a68",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "760 - 980 sq ft",
  "property_sqft_min": "760",
  "property_sqft_max": "980",
  "property_price_range": null,
  "property_price_min": "1299",
  "property_price_max": null,
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/ParkPalomaApartments#",
  "property_instagram_url": "https://www.instagram.com/parkpalomaapts/#",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJGyKGvDgMK4cR1L8NFvfwMu0",
  "property_youtube_url": "https://www.youtube.com/watch?v=4MHKOF4Q84s&t=84",
  "property_yelp_url": "https://www.yelp.com/biz/park-paloma-apartments-phoenix-3",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Park Paloma",
  "property_home_romance_title": "Embrace Life and Love in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Park Paloma in Phoenix, AZ, where contemporary living meets convenience. Choose from spacious one- or two-bedroom floor plans, all ideally designed with modern amenities. Enjoy a vibrant lifestyle with a stunning pool, fitness center, and pet-friendly spaces, all while savoring unique community events. Your perfect home awaits!",
  "property_home_floorplans_blurb": "Welcome to Park Paloma, where vibrant living meets serene spaces in Phoenix, AZ. Choose from our thoughtfully designed one and two-bedroom apartments, each crafted for comfort and style. Browse our available homes today and find the perfect floor plan that suits your lifestyle amidst the beautiful backdrop of the desert.",
  "property_home_gallery_blurb": "Welcome to Park Paloma, where luxury meets convenience in vibrant Phoenix, AZ. Enjoy spacious one and two-bedroom floor plans designed with modern finishes and energy-efficient amenities. Unwind by the pool, socialize in the clubhouse, or let your pet roam in our bark park. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Park Paloma in Phoenix, AZ, find your perfect retreat in spacious one or two-bedroom floor plans. Nestled amid vibrant local attractions, enjoy art at the Phoenix Art Museum, explore nature at the Desert Botanical Garden, or dive into culture at the nearby Heard Museum. Experience exceptional living surrounded by community highlights.",
  "property_home_reviews_blurb": "At Park Paloma in Phoenix, AZ, finding your perfect home is just the beginning. Residents rave about the exceptional care from our community managers, including Gianna and Mirria, who ensure an easy living experience. As one resident said, \"Gianna is the BEST manager we have ever had.\" Join our vibrant community today!",
  "property_neighborhood_blurb": "Nestled in the heart of Phoenix, Park Paloma offers more than just stylish one and two-bedroom apartments. Enjoy easy access to cultural gems like the Phoenix Art Museum and Arizona Science Center, alongside beautiful parks and top-rated schools. Experience a community where lifestyle and convenience meet just outside your door!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Park Paloma in Phoenix, AZ, every detail is crafted for your convenience and comfort. From stylish, fully renovated homes to inviting social spaces, our amenities—like a fitness center, serene courtyard, and 24/7 emergency maintenance—enhance your lifestyle. Elevate your living experience today; your new home awaits!",
  "property_applynow_blurb": "Experience urban living at Park Paloma, where stylish one and two-bedroom apartments meet exceptional amenities. Enjoy 24/7 concierge services, a lavish pool, and a pet play area, all nestled in sunny Phoenix. Your perfect home awaits—embrace convenience, comfort, and community. Apply online and secure your slice of paradise today!",
  "property_contactus_blurb": "At Park Paloma in sunny Phoenix, AZ, our thoughtfully designed one and two-bedroom floor plans cater to your every need. Whether you seek a cozy retreat or a spacious sanctuary, we have the perfect layout for you. Have questions? Contact our leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Park Paloma in sunny Phoenix, AZ, our diverse floor plans feature cozy one-bedroom retreats and spacious two-bedroom sanctuaries. Have questions? Our FAQs page offers insightful answers to help you navigate life at our vibrant community. Discover how Park Paloma can be your ideal home today!",
  "property_floorplans_blurb": "At Park Paloma in vibrant Phoenix, AZ, our thoughtfully designed floor plans cater to every lifestyle. Choose from spacious one-bedroom retreats or expansive two-bedroom layouts, each crafted for comfort and convenience. Browse our available apartment homes today and uncover the perfect space that reflects your unique style and needs.",
  "property_gallery_blurb": "At Park Paloma in Phoenix, AZ, luxury blends seamlessly with comfort. Envision your life in our thoughtfully designed one and two-bedroom apartments, complete with modern amenities like a chic clubhouse, pet-friendly play areas, and a relaxing poolside oasis. Imagine the possibilities—your new home awaits!",
  "property_interactivemap_blurb": "At Park Paloma in sunny Phoenix, AZ, our vibrant community offers meticulously designed one and two-bedroom apartments with essential amenities like a state-of-the-art fitness center, serene courtyard, and inviting clubhouse. Use our interactive community map to find your perfect home amidst luxury and convenience today!",
  "property_pets_blurb": "At Park Paloma in vibrant Phoenix, AZ, your four-legged friends feel right at home! With a pet-friendly policy that includes a spacious park for roaming, our community embraces comfort for both you and your pets. Join us, and let your furry companions thrive in style!",
  "property_referafriend_blurb": "At Park Paloma in sunny Phoenix, AZ, our inviting one- and two-bedroom floor plans offer the perfect blend of comfort and style. Great friends make great neighbors—refer a friend today and unlock the door to an exceptional living experience together in our vibrant community!",
  "property_residentaccess_blurb": "At Park Paloma in sunny Phoenix, AZ, our one and two-bedroom floor plans offer the perfect blend of comfort and style. Access your resident portal to effortlessly pay rent, schedule maintenance, and enjoy hassle-free living. Your convenience awaits—log in today for a seamless apartment experience!",
  "property_reviews_blurb": "At Park Paloma in Phoenix, AZ, our residents rave about the tight-knit, friendly atmosphere fostered by our dedicated team. With glowing testimonials like, “Gianna is the BEST manager we have ever had,” it's clear that exceptional service and community support make us a great place to call home. See what our residents have to say about living at our community!",
  "property_created_at": "1762201171201",
  "property_scheduletour_blurb": "At Park Paloma in vibrant Phoenix, AZ, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Experience modern living surrounded by delightful amenities and a welcoming community. Curious about life here? Schedule a tour and read firsthand accounts from our residents who call Park Paloma home!",
  "property_thankyou_blurb": "Thank you for reaching out to Park Paloma in sunny Phoenix, AZ! Our inviting one- and two-bedroom floor plans offer a perfect blend of comfort and style. Our team will be in touch shortly to help you find your ideal home in our vibrant community. Stay tuned for exciting updates!",
  "property_virtualtours_blurb": "Welcome to Park Paloma in vibrant Phoenix, AZ! Our thoughtfully designed one and two-bedroom apartments offer spacious layouts to suit your lifestyle. Step into your future home today—take a virtual tour of our beautiful community and see why Park Paloma is the perfect place to thrive!",
  "property_copyright": "2026 All Rights Reserved. Park Paloma",
  "property_seo_title_home": "Park Paloma |  Apartments in Phoenix, AZ",
  "property_seo_description_home": "Experience comfort and luxury at Park Paloma in Phoenix, AZ. Enjoy spacious floor plans, lush amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Phoenix, AZ Apartments for Rent",
  "property_seo_description_floorplans": "Unlock your ideal living space at Park Paloma in Phoenix, AZ. Browse our stunning one and two-bedroom floor plans tailored for your lifestyle!",
  "property_seo_title_amenities": "Amenities | Phoenix, AZ Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Park Paloma in Phoenix, AZ! Enjoy luxury amenities like a fitness center, pool, pet play area, and social events in a beautifully designed community.",
  "property_seo_title_gallery": "Gallery | Apartments in Phoenix, AZ",
  "property_seo_description_gallery": "Imagine life at Park Paloma in Phoenix, AZ: luxurious floor plans, pet-friendly amenities, and a vibrant community. Picture your perfect home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Park Paloma Apartments",
  "property_seo_description_virtualtours": "Step into your future home at Park Paloma, Phoenix! Experience our one and two-bedroom apartments through a virtual tour—your ideal lifestyle awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Park Paloma Apartments",
  "property_seo_description_interactivemap": "Discover your oasis at Park Paloma in Phoenix! Use our interactive map to explore spacious one- and two-bedroom apartments with great amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Phoenix, AZ",
  "property_seo_description_neighborhood": "Experience the vibrant charm of Park Paloma in Phoenix, AZ. Uncover local favorites and hotspots just steps from your front door!",
  "property_seo_title_contact": "Contact Us | Park Paloma",
  "property_seo_description_contact": "Connect with Park Paloma in Phoenix, AZ! Explore one and two-bedroom floor plans that match your lifestyle. Our leasing team is ready to assist you!",
  "property_seo_title_faqs": "FAQs | Apartments in Phoenix, AZ",
  "property_seo_description_faqs": "Explore Park Paloma’s FAQs for answers about living in Phoenix’s top community, with exceptional amenities and spacious homes!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Phoenix, AZ",
  "property_seo_description_reviews": "Discover why residents love Park Paloma in Phoenix! Read reviews and explore our vibrant community with top-tier amenities that feel like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Phoenix, AZ",
  "property_seo_description_applynow": "Discover luxury at Park Paloma, Phoenix! Modern apartments with amazing amenities—lease online and find your dream home today!",
  "property_seo_title_residentaccess": "Resident Access | Park Paloma",
  "property_seo_description_residentaccess": "Login to Park Paloma's resident portal for seamless rent payments, easy maintenance requests, and exclusive community updates—all in one place!",
  "property_seo_title_referafriend": "Refer A Friend | Park Paloma",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Park Paloma in Phoenix, AZ, and enhance your community experience together! Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Park Paloma",
  "property_seo_description_scheduletour": "Experience vibrant living at Park Paloma in Phoenix, AZ. Schedule a personalized tour today and envision your future in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Park Paloma",
  "property_seo_description_privacy": "Your privacy matters at Park Paloma! Learn how we protect your information and maintain trust in our vibrant Phoenix, AZ apartment community.",
  "property_seo_title_accessibility": "Website Accessibility | Park Paloma",
  "property_seo_description_accessibility": "At Park Paloma in Phoenix, AZ, we focus on accessibility. Enjoy inclusive features for your comfort. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Park Paloma",
  "property_seo_description_sitemap": "Easily find your ideal Phoenix apartment at Park Paloma! Check out our sitemap for a seamless exploration of our offerings. Easy living awaits!",
  "property_seo_title_thankyou": "Thank You | Park Paloma",
  "property_seo_description_thankyou": "Thank you for reaching out to Park Paloma in Phoenix! Our team will connect with you soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Phoenix, AZ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293570530",
  "amenities": [
    {
      "id": "custom_c04951be-1869-47a2-b077-b3fa71b408aa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Jacuzzi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0aaab72e-3e49-4bf0-a224-55f59c02b697",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3fbd0285-848f-4508-b538-87ad1cd61abe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Assigned Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8a47418a-e7a0-45b2-a461-587689bc176e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Courtyards",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fd50e2fc-86d9-44c1-8417-ebd10bf0b192",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_98df4e4b-9b2e-4ae8-b34d-299dd6666c8a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a101c161-dfda-4afb-899d-b7f4aa7fa147",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Location",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_28a1ec32-1064-47f0-9364-3701639601cc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Copy/Fax Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_630e4ed9-bae3-40aa-9d72-f9710a49a81f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Close to Shopping, Dining Bus Routes & Much More!",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_77ca152b-00bb-47ed-bde6-6c5365e0f3b9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ec2f0592-90da-4c7f-a8b4-fee31307e1fd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Pest Control Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee67a0eb-1574-4d16-8e57-ac835eedac06",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e2dc7e47-6522-4dab-8f3d-d68cd5e7db88",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_11a90375-17d4-40c7-b065-4b46f3bffc44",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c173c6c4-dde7-40ad-aaef-76a7edf5049c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_837f8dc8-a489-41c8-8f5f-f06943901ed6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b47a0a90-939d-400a-a999-aee78a442cbe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_78278dc6-1acb-46d1-b1df-9baad58638d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_230f55b1-0f39-4fca-baf9-bc70c058e835",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Professional Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_71c2562d-89db-4cbf-854b-1b22211bb685",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Responsive Management Team",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cef2d195-1e0f-47e1-83f4-2478605849c0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Freeway Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_27f1aff2-c67b-4500-a061-692962082ffd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Credit Cards Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d1960070-6161-44d0-aec1-eed6be88fe2f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5ad98ac-bdc8-4e4d-ab46-374179cbb8c6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3b40d495-d22f-44b0-a9c0-00373cbc129f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_20bdc4d0-9ad9-4b71-b391-3ee5544102ea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8db57d1d-831a-4658-9947-b1d668df0f2c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Walk In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3939d335-4fcf-4cc6-978a-747c3020140d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b272f964-8bfb-4e50-8a23-b39f9afa5580",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Linen Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c49057c7-f512-42af-b4d2-155af8e5ba63",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a4354107-89a7-46dc-8148-b2781ac748a0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_03ee0eb8-df81-47c6-a60a-99b4d20cd2bb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_94cbdedf-6860-4558-a49d-f25bd5834602",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Frost Free Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_484e0e5b-3e37-4be0-babe-3fc1839c415a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Floorplans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a36c016d-1241-4155-820f-805e0a188a18",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Inspired Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_15be9786-baf0-4b5d-8cb3-268bf29033ed",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Pre-Installed Wi-Fi with 1st Month Free from Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_621155e4-9fdc-470a-a9a3-941361936788",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_366b8dae-bb97-4efc-899c-f5a98f963b1a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_85b23897-8a23-427b-9465-cb780373a255",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_060c2e39-5dad-449d-ac92-1019ed5c23cd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69ca503e-3153-462f-bef4-fb079bc59c9f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c01f7713-688e-4cad-9357-15203b81687f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aea9afed-4439-4bd3-9eb2-3cba442dd8bc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_58378e5e-f11a-435d-a25e-ef196e5c5bb6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e392e67c-32bd-4472-9649-a124ef17fa49",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Reserved Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_36bca334-b60a-4f00-961c-f5490fec0490",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Pets Welcome",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0a24cb1d-1d6a-44c8-a5b5-a888706afa2a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_2e212a5a-5e5d-48c9-8e89-351d38e9b2f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d4-0064-767b-b700-e4d3e54f2e6d.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and spa area with lounge chairs and umbrellas.",
        "public_id": "019d02d4-0064-767b-b700-e4d3e54f2e6d",
        "storage_key": "property/6767906449166801/019d02d4-0064-767b-b700-e4d3e54f2e6d.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool and relaxing spa, perfect for unwinding and soaking up the sun.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and spa area with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_187bd62e-ef50-4d32-80a9-52e784b7ca66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-f921-7517-8cc7-0d3e98da5710.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d02d3-f921-7517-8cc7-0d3e98da5710",
        "storage_key": "property/6767906449166801/019d02d3-f921-7517-8cc7-0d3e98da5710.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and vibrant umbrellas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bbc660ea-6751-4902-8a4f-f34a43fc4b9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-f890-7559-a3e7-682e218b75f9.webp",
      "image_media": {
        "alt_text": "Swimming pool area with lounge chairs and umbrellas",
        "public_id": "019d02d3-f890-7559-a3e7-682e218b75f9",
        "storage_key": "property/6767906449166801/019d02d3-f890-7559-a3e7-682e218b75f9.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and shaded umbrellas for relaxation.",
      "link": "",
      "alt_text": "Swimming pool area with lounge chairs and umbrellas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a615e575-9676-403c-acc6-62d487d944cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-f18d-73ed-82f1-4253905ae1dd.webp",
      "image_media": {
        "alt_text": "Outdoor grills and swimming pool area with lounge chairs and umbrellas.",
        "public_id": "019d02d3-f18d-73ed-82f1-4253905ae1dd",
        "storage_key": "property/6767906449166801/019d02d3-f18d-73ed-82f1-4253905ae1dd.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Enjoy our beautiful outdoor grilling area and refreshing swimming pool, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Outdoor grills and swimming pool area with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3527eb39-fc1d-4b0f-b1c4-fcfe6f0e2475",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-e1c6-72be-96fc-b9609bba8ed6.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding apartment buildings with red tile roofs.",
        "public_id": "019d02d3-e1c6-72be-96fc-b9609bba8ed6",
        "storage_key": "property/6767906449166801/019d02d3-e1c6-72be-96fc-b9609bba8ed6.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool at our apartment community. Enjoy the sunny weather and lush landscaping surrounding the building.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool and surrounding apartment buildings with red tile roofs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dc24259e-b4e0-4d94-8bb9-ada07bd65db8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-d53b-71e5-88d6-c827391266b9.webp",
      "image_media": {
        "alt_text": "Lobby with modern furniture and a view of the pool area.",
        "public_id": "019d02d3-d53b-71e5-88d6-c827391266b9",
        "storage_key": "property/6767906449166801/019d02d3-d53b-71e5-88d6-c827391266b9.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed lobby, featuring comfortable seating and a direct view of the resort-style pool.",
      "link": "",
      "alt_text": "Lobby with modern furniture and a view of the pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_688e3f29-e919-48e2-a76d-21551ee6dd26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-cfde-766f-a3c8-d3db1a7b94dd.webp",
      "image_media": {
        "alt_text": "Treadmill and free weights in a well-equipped fitness center.",
        "public_id": "019d02d3-cfde-766f-a3c8-d3db1a7b94dd",
        "storage_key": "property/6767906449166801/019d02d3-cfde-766f-a3c8-d3db1a7b94dd.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring treadmills, free weights, and plenty of space to get your workout in.",
      "link": "",
      "alt_text": "Treadmill and free weights in a well-equipped fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4745285e-4fff-4b3d-aa24-c5168f0845c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-b6ea-721e-b331-7075cff024cb.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and desert landscaping.",
        "public_id": "019d02d3-b6ea-721e-b331-7075cff024cb",
        "storage_key": "property/6767906449166801/019d02d3-b6ea-721e-b331-7075cff024cb.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "View of the exteriors of the apartment buildings, showcasing their stucco facades, red tile roofs, and private balconies. Landscaped with desert plants and gravel for low-maintenance beauty.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and desert landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_27449aea-c8d4-40fb-b494-9f0f53aed469",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-5ce1-774a-8a3e-dee5d22e171d.webp",
      "image_media": {
        "alt_text": "Two stainless steel grills with side shelves and built-in thermometers are set up on a paved patio area.",
        "public_id": "019d02d3-5ce1-774a-8a3e-dee5d22e171d",
        "storage_key": "property/6767906449166801/019d02d3-5ce1-774a-8a3e-dee5d22e171d.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our community grills, perfect for gathering with friends and neighbors.",
      "link": "",
      "alt_text": "Two stainless steel grills with side shelves and built-in thermometers are set up on a paved patio area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fd6e6b98-fc97-4fd5-9148-e0160acb81f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-4f05-71b2-91d1-0952e4db338d.webp",
      "image_media": {
        "alt_text": "Park Paloma Apartment Homes monument sign with address 2930",
        "public_id": "019d02d3-4f05-71b2-91d1-0952e4db338d",
        "storage_key": "property/6767906449166801/019d02d3-4f05-71b2-91d1-0952e4db338d.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Welcome to Park Paloma Apartment Homes, located at 2930. This monument sign welcomes residents and visitors to the community.",
      "link": "",
      "alt_text": "Park Paloma Apartment Homes monument sign with address 2930",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_edea8a28-30b4-4880-8304-1f7ee46d6c83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d4-27d1-72e1-8dc1-6fa1de3b43c7.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and access to balcony.",
        "public_id": "019d02d4-27d1-72e1-8dc1-6fa1de3b43c7",
        "storage_key": "property/6767906449166801/019d02d4-27d1-72e1-8dc1-6fa1de3b43c7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, coffee table, and a sliding glass door leading to a private balcony, perfect for relaxing outdoors.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, and access to balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4fcd2cc3-c7cd-4bcb-8986-e1285d46cd3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d4-29f9-7782-8b98-96c756b26cce.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019d02d4-29f9-7782-8b98-96c756b26cce",
        "storage_key": "property/6767906449166801/019d02d4-29f9-7782-8b98-96c756b26cce.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with modern furnishings and decorative art.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f12bbeb9-97b5-482d-a989-4cd7a5f61db3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d4-1a06-723c-a819-d211a506b9fb.webp",
      "image_media": {
        "alt_text": "Luxury bedroom with king-size bed, plush bedding, and modern decor.",
        "public_id": "019d02d4-1a06-723c-a819-d211a506b9fb",
        "storage_key": "property/6767906449166801/019d02d4-1a06-723c-a819-d211a506b9fb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this beautifully appointed bedroom, featuring a king-size bed, elegant furnishings, and serene artwork.",
      "link": "",
      "alt_text": "Luxury bedroom with king-size bed, plush bedding, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8a34f582-9796-413e-b5b1-d627b7404121",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d4-1252-7649-aa77-c0db37bffeac.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, dresser, and large window.",
        "public_id": "019d02d4-1252-7649-aa77-c0db37bffeac",
        "storage_key": "property/6767906449166801/019d02d4-1252-7649-aa77-c0db37bffeac.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed with upholstered headboard, a ceiling fan, ample closet space, and a large window providing natural light.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, dresser, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec80fa28-70bb-4287-845b-7ff4935ff8e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d4-0c4c-7398-b57a-ad6d95d0468a.webp",
      "image_media": {
        "alt_text": "Bathroom with white bathtub, toilet, and vanity with sink and mirror.",
        "public_id": "019d02d4-0c4c-7398-b57a-ad6d95d0468a",
        "storage_key": "property/6767906449166801/019d02d4-0c4c-7398-b57a-ad6d95d0468a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a modern vanity with a sink and mirror, a clean white bathtub with shower curtain, and a toilet.",
      "link": "",
      "alt_text": "Bathroom with white bathtub, toilet, and vanity with sink and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_06fa3f70-9520-40b8-ae4e-3fecddc80ecf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-a5d6-702b-87ad-bdd61fa7207c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and a decorative tile backsplash.",
        "public_id": "019d02d3-a5d6-702b-87ad-bdd61fa7207c",
        "storage_key": "property/6767906449166801/019d02d3-a5d6-702b-87ad-bdd61fa7207c.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Beautifully renovated kitchen featuring sleek cabinetry, a stylish tile backsplash, and modern stainless steel appliances. Perfect for home chefs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and a decorative tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_771ca944-5491-4dc6-9d73-dd4f0b5dbc51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-9f93-7745-9cda-c5fa0432757b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, patterned backsplash, stainless steel appliances, and quartz countertops.",
        "public_id": "019d02d3-9f93-7745-9cda-c5fa0432757b",
        "storage_key": "property/6767906449166801/019d02d3-9f93-7745-9cda-c5fa0432757b.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Step into a beautifully updated kitchen featuring light wood cabinetry, a striking geometric backsplash, and sleek quartz countertops. This space is equipped with stainless steel appliances and ample counter space for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with light wood cabinets, patterned backsplash, stainless steel appliances, and quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae1afa31-ee9e-42c8-ba29-10618014464b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-e8e8-70b2-9669-3b17005cf134.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with stainless steel appliances, a breakfast bar with stools, and a table with chairs.",
        "public_id": "019d02d0-e8e8-70b2-9669-3b17005cf134",
        "storage_key": "property/6767906449166801/019d02d0-e8e8-70b2-9669-3b17005cf134.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "A bright and airy dining area and kitchen space featuring a stainless steel refrigerator, elegant backsplash, and a convenient breakfast bar with seating.",
      "link": "",
      "alt_text": "Dining area and kitchen with stainless steel appliances, a breakfast bar with stools, and a table with chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_6e07ab6e-218a-459e-afc9-640400e27701",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Tarbell's",
      "poi_type": "Restaurants",
      "poi_address": "3213 E Camelback Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Upscale restaurant & bar serving American fare paired with global wines in a chic space.",
      "poi_long_description": "Upscale restaurant & bar serving American fare paired with global wines in a chic space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-4d02-77e6-8e17-2d9e6ca9454a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-4d02-77e6-8e17-2d9e6ca9454a",
        "storage_key": "property/6767906449166801/019d02d1-4d02-77e6-8e17-2d9e6ca9454a.webp",
        "width": 1080,
        "height": 739
      },
      "poi_business_url": "http://www.tarbells.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9933329012119375508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tarbells",
      "poi_latitude": "33.5091295",
      "poi_longitude": "-112.0124202",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-955-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhecLBRANK4cRlA51hBtG2ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_36151630-d695-4050-9cba-44bdf8b1f768",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Steak 44",
      "poi_type": "Restaurants",
      "poi_address": "5101 N 44th St, Phoenix, AZ 85018, USA",
      "poi_short_description": "High-end steakhouse featuring gourmet filets, seafood & classic entrees in an elegant, modern venue.",
      "poi_long_description": "High-end steakhouse featuring gourmet filets, seafood & classic entrees in an elegant, modern venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-4c64-72ea-b1bf-6c0dbf7bff33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-4c64-72ea-b1bf-6c0dbf7bff33",
        "storage_key": "property/6767906449166801/019d02d1-4c64-72ea-b1bf-6c0dbf7bff33.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.steak44.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11444269267017849278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "steak-44",
      "poi_latitude": "33.5114386",
      "poi_longitude": "-111.9860172",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-271-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuYlv9fAMK4cRvtmElkM20p4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_191c40a8-3175-4317-849a-c336a88d1145",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "The Gladly",
      "poi_type": "Restaurants",
      "poi_address": "2201 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Creative, globally inspired New American fare joins a menu of 200+ whiskeys at this stylish bistro.",
      "poi_long_description": "Creative, globally inspired New American fare joins a menu of 200+ whiskeys at this stylish bistro.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-4cb4-74e8-b193-13331147640d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-4cb4-74e8-b193-13331147640d",
        "storage_key": "property/6767906449166801/019d02d1-4cb4-74e8-b193-13331147640d.webp",
        "width": 1280,
        "height": 568
      },
      "poi_business_url": "http://www.thegladly.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16512332448216501891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-gladly",
      "poi_latitude": "33.5090973",
      "poi_longitude": "-112.0339058",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-759-8132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkxpMR28NK4cRg84ZJeCWJ-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c273fb39-5d93-43bd-93f1-659122bbeb3a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Buck & Rider Phoenix",
      "poi_type": "Restaurants",
      "poi_address": "4225 E Camelback Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Raw bar fare, meat dishes and craft drinks offered in a stylish dining room with patio seating.",
      "poi_long_description": "Raw bar fare, meat dishes and craft drinks offered in a stylish dining room with patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-4c71-7774-9bc2-a375561b5444.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-4c71-7774-9bc2-a375561b5444",
        "storage_key": "property/6767906449166801/019d02d1-4c71-7774-9bc2-a375561b5444.webp",
        "width": 880,
        "height": 586
      },
      "poi_business_url": "https://www.buckandrider.com/?utm_source=GMB&utm_medium=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11728671695188025866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buck--rider-phoenix",
      "poi_latitude": "33.509183",
      "poi_longitude": "-111.988719",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-346-0110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1c1vcvoMK4cRCmLc_sOcxKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_73d87559-b6be-41fc-80f0-12545dc48cd7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Chelsea’s Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "5040 N 40th St, Phoenix, AZ 85018, USA",
      "poi_short_description": "Bustling, industrial-chic eatery featuring American comfort fare & a patio overlooking the canal.",
      "poi_long_description": "Bustling, industrial-chic eatery featuring American comfort fare & a patio overlooking the canal.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-5263-756a-94ad-6b9957373059.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-5263-756a-94ad-6b9957373059",
        "storage_key": "property/6767906449166801/019d02d1-5263-756a-94ad-6b9957373059.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://chelseaskitchenaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15919152627754095207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chelseas-kitchen",
      "poi_latitude": "33.5111864",
      "poi_longitude": "-111.9955915",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 602-957-2555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbTTqyvwMK4cRZ1KCvvgw7Nw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_2eb4b00c-bca1-4f3c-b016-e0b2d116ad36",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "La Grande Orange Grocery & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "4410 N 40th St, Phoenix, AZ 85018, USA",
      "poi_short_description": "Pastries, creative breakfasts & gourmet pizzas star at this chic bakery/cafe with a grocery section.",
      "poi_long_description": "Pastries, creative breakfasts & gourmet pizzas star at this chic bakery/cafe with a grocery section.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-5333-715a-85e6-ac19fdacd96f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-5333-715a-85e6-ac19fdacd96f",
        "storage_key": "property/6767906449166801/019d02d1-5333-715a-85e6-ac19fdacd96f.webp",
        "width": 1280,
        "height": 909
      },
      "poi_business_url": "https://lagrandeorangegrocery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11939383460360206971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-grande-orange-grocery--pizzeria",
      "poi_latitude": "33.5022458",
      "poi_longitude": "-111.9957387",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-840-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dce2-71e5-965f-e5bb49f4455b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dce2-71e5-965f-e5bb49f4455b",
        "storage_key": "property/6767906449166801/019d02d1-dce2-71e5-965f-e5bb49f4455b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF--Xa_8MK4cRe7rx5_81saU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d4b4d451-3210-459d-9f69-4c510e0d0da5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Postino Arcadia",
      "poi_type": "Restaurants",
      "poi_address": "3939 E Campbell Ave #100, Phoenix, AZ 85018, USA",
      "poi_short_description": "Italian cafe serving a wide selection of bruschetta & wine in rustic-chic digs with outdoor seating.",
      "poi_long_description": "Italian cafe serving a wide selection of bruschetta & wine in rustic-chic digs with outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-5368-736c-ad8c-2e0c8e51376f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-5368-736c-ad8c-2e0c8e51376f",
        "storage_key": "property/6767906449166801/019d02d1-5368-736c-ad8c-2e0c8e51376f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.postinowinecafe.com/locations/postino-arcadia",
      "poi_directions_map_url": "https://maps.google.com/?cid=15269607705781961356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "postino-arcadia",
      "poi_latitude": "33.5021572",
      "poi_longitude": "-111.996314",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-852-3939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fTXDP8MK4cRjIKzek6L6NM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_06cbc6a7-85a6-4605-bbe8-fa5f5c751857",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "True Food Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "2502 E Camelback Rd Suite 135, Phoenix, AZ 85016, USA",
      "poi_short_description": "Relaxed, eco-chic chain serving health-conscious fare, including vegan options, plus cocktails.",
      "poi_long_description": "Relaxed, eco-chic chain serving health-conscious fare, including vegan options, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-53a7-767a-b648-e22b1f4e63de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-53a7-767a-b648-e22b1f4e63de",
        "storage_key": "property/6767906449166801/019d02d1-53a7-767a-b648-e22b1f4e63de.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.truefoodkitchen.com/locations/phoenix/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5440431876249256819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "true-food-kitchen",
      "poi_latitude": "33.5103589",
      "poi_longitude": "-112.02769",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-774-3488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_T4sdGwNK4cRc4OMgPdLgEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_74500476-21d4-4643-9b72-77e69b1a7c56",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Seasons 52",
      "poi_type": "Restaurants",
      "poi_address": "2502 E Camelback Rd Suite 140, Phoenix, AZ 85016, USA",
      "poi_short_description": "Rotating menu of seasonal American dishes alongside international wines in an upscale setting.",
      "poi_long_description": "Rotating menu of seasonal American dishes alongside international wines in an upscale setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-59c2-73f9-ac1c-46f0e11dcdb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-59c2-73f9-ac1c-46f0e11dcdb5",
        "storage_key": "property/6767906449166801/019d02d1-59c2-73f9-ac1c-46f0e11dcdb5.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.seasons52.com/locations/az/phoenix/phoenix/4517?cmpid=br:s52_ag:ie_ch:loc_ca:S52GMB_sn:gmb_gt:phoenix-az-4517_pl:locurl_rd:1016",
      "poi_directions_map_url": "https://maps.google.com/?cid=2747344481764541777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seasons-52",
      "poi_latitude": "33.51044",
      "poi_longitude": "-112.02676",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 602-840-5252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_T4sdGwNK4cRUYU0B0CHICY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1e15aaff-8d55-4a50-b346-83ef2825c3f9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Snooze, an A.M. Eatery",
      "poi_type": "Restaurants",
      "poi_address": "2045 E Camelback Rd A17, Phoenix, AZ 85016, USA",
      "poi_short_description": "Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails.",
      "poi_long_description": "Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-5a1e-7519-b7a6-e10d9b66f72c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-5a1e-7519-b7a6-e10d9b66f72c",
        "storage_key": "property/6767906449166801/019d02d1-5a1e-7519-b7a6-e10d9b66f72c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.snoozeeatery.com/restaurant/arizona/town-country/?utm_source=Google&utm_medium=BusinessListing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15059823724261277884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snooze-an-am-eatery",
      "poi_latitude": "33.508153",
      "poi_longitude": "-112.0371596",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-725-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfyl06WUNK4cRvACYCOM9_9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_cac2be4a-1e57-491c-8e5c-49f024fbc6a3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Matt's Big Breakfast",
      "poi_type": "Restaurants",
      "poi_address": "3118 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Contemporary American cafe specializing in carefully sourced lunches & breakfasts.",
      "poi_long_description": "Contemporary American cafe specializing in carefully sourced lunches & breakfasts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-5ae3-7307-912a-a9dc3267385b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-5ae3-7307-912a-a9dc3267385b",
        "storage_key": "property/6767906449166801/019d02d1-5ae3-7307-912a-a9dc3267385b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mattsbigbreakfast.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16099837459790877428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matts-big-breakfast",
      "poi_latitude": "33.510993",
      "poi_longitude": "-112.015325",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-840-3450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJodAfrhENK4cR9NJcfN4cbt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_730ecef9-8832-4247-93bd-45cde1ef3958",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Hopdoddy Burger Bar",
      "poi_type": "Restaurants",
      "poi_address": "2033 E Camelback Rd Suite A13, Phoenix, AZ 85016, USA",
      "poi_short_description": "Casual chain for craft burgers, fries, milkshakes and beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-5adb-7285-b005-c8c7cf1ad18c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-5adb-7285-b005-c8c7cf1ad18c",
        "storage_key": "property/6767906449166801/019d02d1-5adb-7285-b005-c8c7cf1ad18c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hopdoddy.com/locations/camelback",
      "poi_directions_map_url": "https://maps.google.com/?cid=4082285979846994691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hopdoddy-burger-bar",
      "poi_latitude": "33.508341",
      "poi_longitude": "-112.0374666",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 602-242-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo4bqwGUNK4cRA2tWRHgxpzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_71766936-e933-47f2-9a87-33842aa4c5af",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Renata's Hearth",
      "poi_type": "Restaurants",
      "poi_address": "2400 E Missouri Ave, Phoenix, AZ 85016, USA",
      "poi_short_description": "Restaurant inside the Arizona Biltmore, A Waldorf Astoria Resort in the Camelback East Village neighborhood.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-60ef-756f-9c06-0c6ab0fec8b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-60ef-756f-9c06-0c6ab0fec8b0",
        "storage_key": "property/6767906449166801/019d02d1-60ef-756f-9c06-0c6ab0fec8b0.webp",
        "width": 640,
        "height": 427
      },
      "poi_business_url": "https://www.renatashearth.com/?SEO_id=GMB--R-PHXBMOL-3&y_source=1_MjY1ODk0MDgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1870894433239375527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renatas-hearth",
      "poi_latitude": "33.5232388",
      "poi_longitude": "-112.022425",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-954-2507",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJx_6vEsNK4cRpx59GZPA9hk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d20514da-76a8-46b4-a1b4-ea9d2508ff49",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "The Capital Grille",
      "poi_type": "Restaurants",
      "poi_address": "2502 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Outpost of the upscale steakhouse chain offers classic American fare & a clubby, refined setting.",
      "poi_long_description": "Outpost of the upscale steakhouse chain offers classic American fare & a clubby, refined setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-61b2-7119-be23-4bdaf5056f45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-61b2-7119-be23-4bdaf5056f45",
        "storage_key": "property/6767906449166801/019d02d1-61b2-7119-be23-4bdaf5056f45.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.thecapitalgrille.com/locations/az/phoenix/phoenix/8017?cmpid=br:tcg_ag:ie_ch:loc_ca:TCGGMB_sn:gmb_gt:phoenix-az-8017_pl:locurl_rd:1013",
      "poi_directions_map_url": "https://maps.google.com/?cid=10408594178182247872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-capital-grille",
      "poi_latitude": "33.510226",
      "poi_longitude": "-112.027072",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-952-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_T4sdGwNK4cRwHXACULBcpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_a5057d69-4ecf-44fc-ab2a-2b7fe2b656ee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Blanco Cocina + Cantina",
      "poi_type": "Restaurants",
      "poi_address": "2502 E Camelback Rd #122, Phoenix, AZ 85016, USA",
      "poi_short_description": "Stylish Mexican eatery with outdoor seating for traditional eats & a wide range of tequilas.",
      "poi_long_description": "Stylish Mexican eatery with outdoor seating for traditional eats & a wide range of tequilas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-62e2-7728-9914-d9876756af1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-62e2-7728-9914-d9876756af1e",
        "storage_key": "property/6767906449166801/019d02d1-62e2-7728-9914-d9876756af1e.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "https://www.blancotacostequila.com/locations/phoenix-az-biltmore-fashion-park/?utm_source=Google&utm_medium=Organic&utm_campaign=Maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5831222121423744148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blanco-cocina--cantina",
      "poi_latitude": "33.5103867",
      "poi_longitude": "-112.0284712",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-429-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dd27-70f9-8a1b-c26a106176fd",
        "storage_key": "property/6767906449166801/019d02d1-dd27-70f9-8a1b-c26a106176fd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_lRDGwNK4cRlKzc0Z-p7FA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_064b4c8c-c31b-45dc-9010-261a8d5ca68b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1625 N 44th St, Phoenix, AZ 85008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-629d-711b-9f7b-7133e91b9125.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-629d-711b-9f7b-7133e91b9125",
        "storage_key": "property/6767906449166801/019d02d1-629d-711b-9f7b-7133e91b9125.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/phoenix-az-pharmacies/1625-n-44th-st-phoenix-az-85008/storeid=3500?WT.mc_id=LS_GOOGLE_RX_3500",
      "poi_directions_map_url": "https://maps.google.com/?cid=96316166809528989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.4664848",
      "poi_longitude": "-111.9866226",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-275-0120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dce3-77a4-8b1a-2263a6a16f51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dce3-77a4-8b1a-2263a6a16f51",
        "storage_key": "property/6767906449166801/019d02d1-dce3-77a4-8b1a-2263a6a16f51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKS0P6iUMK4cRnSrPHAsvVgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_cb41bd9c-d11e-49ea-a5db-79a63d0ef59b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "4750 E Indian School Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-67e8-7188-bd1a-8a1120170d90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-67e8-7188-bd1a-8a1120170d90",
        "storage_key": "property/6767906449166801/019d02d1-67e8-7188-bd1a-8a1120170d90.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.safeway.com/safeway/az/phoenix/4750-e-indian-school-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=938932942716915302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "33.4959552",
      "poi_longitude": "-111.9792697",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-840-2161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dce2-71e5-965f-e5bb49f4455b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dce2-71e5-965f-e5bb49f4455b",
        "storage_key": "property/6767906449166801/019d02d1-dce2-71e5-965f-e5bb49f4455b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO-dZ51wMK4cRZs6NZonCBw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ff72ffbc-82dd-4ba6-8008-68834d70c604",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Fry's Food And Drug",
      "poi_type": "Shopping & Retail",
      "poi_address": "4505 E Thomas Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Outpost of a grocery store chain with typical offerings like produce, meat & household supplies.",
      "poi_long_description": "Outpost of a grocery store chain with typical offerings like produce, meat & household supplies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-6945-712d-a1c6-e65d01279735.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-6945-712d-a1c6-e65d01279735",
        "storage_key": "property/6767906449166801/019d02d1-6945-712d-a1c6-e65d01279735.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.frysfood.com/stores/details/660/00135?cid=loc66000135_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14119835492756590871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frys-food-and-drug",
      "poi_latitude": "33.479147",
      "poi_longitude": "-111.9840932",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 602-952-1288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dce2-71e5-965f-e5bb49f4455b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dce2-71e5-965f-e5bb49f4455b",
        "storage_key": "property/6767906449166801/019d02d1-dce2-71e5-965f-e5bb49f4455b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrw6A4jgMK4cRF5G1EJK788M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e23fdbf9-e908-4c54-90af-b761fd9d616a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "AJ's Fine Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "4430 E Camelback Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Gourmet chain with butcher & seafood counters, baked goods & coffees, cheese & market-fresh produce.",
      "poi_long_description": "Gourmet chain with butcher & seafood counters, baked goods & coffees, cheese & market-fresh produce.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-69a4-7485-9b0e-1fd89757556f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-69a4-7485-9b0e-1fd89757556f",
        "storage_key": "property/6767906449166801/019d02d1-69a4-7485-9b0e-1fd89757556f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ajsfinefoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8539842113276649358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ajs-fine-foods",
      "poi_latitude": "33.5105509",
      "poi_longitude": "-111.9854313",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 602-522-0956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dce2-71e5-965f-e5bb49f4455b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dce2-71e5-965f-e5bb49f4455b",
        "storage_key": "property/6767906449166801/019d02d1-dce2-71e5-965f-e5bb49f4455b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4MB2O8MK4cRjp_G7yedg3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_51768e03-ee6a-4495-849e-2d35f960ec8e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3721 E Thomas Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Wide-ranging retailer, offering groceries and household goods alongside services like photo printing and repairs, plus friendly staff, helpful employees and self-checkout options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-6b1b-734f-a953-34b5f339ff98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-6b1b-734f-a953-34b5f339ff98",
        "storage_key": "property/6767906449166801/019d02d1-6b1b-734f-a953-34b5f339ff98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/2515-phoenix-az/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=5974062166260505646&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.4789848",
      "poi_longitude": "-112.0009274",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-685-0555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dce0-7526-be3c-592302260bf1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dce0-7526-be3c-592302260bf1",
        "storage_key": "property/6767906449166801/019d02d1-dce0-7526-be3c-592302260bf1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ88sfF7UNK4cRLtwOZuMh6FI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_6cfe3b96-0550-417c-9362-76847175c459",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "4515 E Thomas Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-719d-775d-a04e-1e1b66c5b946.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-719d-775d-a04e-1e1b66c5b946",
        "storage_key": "property/6767906449166801/019d02d1-719d-775d-a04e-1e1b66c5b946.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.target.com/sl/arcadia-crossing/950",
      "poi_directions_map_url": "https://maps.google.com/?cid=11838815624359217707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.4775638",
      "poi_longitude": "-111.9839212",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 602-952-1797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dce0-7526-be3c-592302260bf1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dce0-7526-be3c-592302260bf1",
        "storage_key": "property/6767906449166801/019d02d1-dce0-7526-be3c-592302260bf1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-SV_8TgMK4cRK4pG6xXsS6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7517ae7b-895d-459b-9404-b3c64aa81e00",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "4821 N 20th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-71b3-740b-a83a-ee245b6b4bed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-71b3-740b-a83a-ee245b6b4bed",
        "storage_key": "property/6767906449166801/019d02d1-71b3-740b-a83a-ee245b6b4bed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/az/phoenix/90/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10694691880053583102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "33.5070967",
      "poi_longitude": "-112.0377182",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-912-9022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dce2-71e5-965f-e5bb49f4455b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dce2-71e5-965f-e5bb49f4455b",
        "storage_key": "property/6767906449166801/019d02d1-dce2-71e5-965f-e5bb49f4455b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoY_8TGQNK4cR_izZHJota5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3397f2c6-1cf6-4c4b-8050-2bfedfd92c67",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4701 N 20th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-72a6-715b-86d1-53e67f2e810c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-72a6-715b-86d1-53e67f2e810c",
        "storage_key": "property/6767906449166801/019d02d1-72a6-715b-86d1-53e67f2e810c.webp",
        "width": 1280,
        "height": 834
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/camelback?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=1444832490836523548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "33.5064733",
      "poi_longitude": "-112.0376627",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-761-4750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dce2-71e5-965f-e5bb49f4455b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dce2-71e5-965f-e5bb49f4455b",
        "storage_key": "property/6767906449166801/019d02d1-dce2-71e5-965f-e5bb49f4455b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2-_kVWQNK4cRHPpA0H4TDRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6f1e1dd5-c332-4b02-b16c-69785a1eab62",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Biltmore Fashion Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "2502 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Upscale shopping mall with high-end department stores & retailers, plus restaurants & fast food.",
      "poi_long_description": "Upscale shopping mall with high-end department stores & retailers, plus restaurants & fast food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-72ed-713a-a7aa-e7f4e1f5b212.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-72ed-713a-a7aa-e7f4e1f5b212",
        "storage_key": "property/6767906449166801/019d02d1-72ed-713a-a7aa-e7f4e1f5b212.webp",
        "width": 1280,
        "height": 1004
      },
      "poi_business_url": "https://www.shopbiltmore.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=14989761710559018186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "biltmore-fashion-park",
      "poi_latitude": "33.5108735",
      "poi_longitude": "-112.0279366",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 602-954-6810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-dce0-7526-be3c-592302260bf1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-dce0-7526-be3c-592302260bf1",
        "storage_key": "property/6767906449166801/019d02d1-dce0-7526-be3c-592302260bf1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_T4sdGwNK4cRyjyfSdtUBtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4674d251-c311-44c9-a953-4bdf4073531c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "4343 E Camelback Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Chain gas station and convenience store offering snacks, drinks, and Amazon pickup services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-7898-767d-8133-7f25618260ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-7898-767d-8133-7f25618260ed",
        "storage_key": "property/6767906449166801/019d02d1-7898-767d-8133-7f25618260ed.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/phoenix/4343-e-camelback-rd/2701752?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11553783635042058330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "33.5092489",
      "poi_longitude": "-111.9874452",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 602-840-2639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e27b-755d-9077-29822d79ec66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e27b-755d-9077-29822d79ec66",
        "storage_key": "property/6767906449166801/019d02d1-e27b-755d-9077-29822d79ec66.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJOTwRovAMK4cRWkBnYgBJV6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_f360003b-ca2e-4e17-8a0b-bc59da1cd9ce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Tavan Elementary School",
      "poi_type": "Education",
      "poi_address": "4610 E Osborn Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-797a-74ed-a298-ab0ffef56d7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-797a-74ed-a298-ab0ffef56d7f",
        "storage_key": "property/6767906449166801/019d02d1-797a-74ed-a298-ab0ffef56d7f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.susd.org/tavan",
      "poi_directions_map_url": "https://maps.google.com/?cid=12914806434234207436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tavan-elementary-school",
      "poi_latitude": "33.488872",
      "poi_longitude": "-111.9819122",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 480-484-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e295-73be-8273-42fdbf41b297",
        "storage_key": "property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3bzpiUMMK4cRzIx1vwacOrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e593b31a-4607-4c6c-9d37-b48e01504659",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Ingleside Middle School",
      "poi_type": "Education",
      "poi_address": "5402 E Osborn Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-79a6-715c-94ba-4624c3723490.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-79a6-715c-94ba-4624c3723490",
        "storage_key": "property/6767906449166801/019d02d1-79a6-715c-94ba-4624c3723490.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.susd.org/ingleside",
      "poi_directions_map_url": "https://maps.google.com/?cid=10122720382479736250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ingleside-middle-school",
      "poi_latitude": "33.488428",
      "poi_longitude": "-111.964301",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-484-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e295-73be-8273-42fdbf41b297",
        "storage_key": "property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE_fPhm0MK4cRup1PLo4ge4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ee6a13a4-06c3-449e-91a8-c866c7e78615",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Arcadia High School",
      "poi_type": "Education",
      "poi_address": "4703 E Indian School Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-7a7b-7644-9d24-5ef771dcfd17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-7a7b-7644-9d24-5ef771dcfd17",
        "storage_key": "property/6767906449166801/019d02d1-7a7b-7644-9d24-5ef771dcfd17.webp",
        "width": 1280,
        "height": 825
      },
      "poi_business_url": "http://susd.org/arcadia",
      "poi_directions_map_url": "https://maps.google.com/?cid=10818557065441764825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arcadia-high-school",
      "poi_latitude": "33.4933776",
      "poi_longitude": "-111.9816129",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-484-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e295-73be-8273-42fdbf41b297",
        "storage_key": "property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXZB2U0MMK4cR2eXy81Q8I5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_d93a66a1-803f-4df9-b27a-b37f93f7ab0f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Hopi Elementary School",
      "poi_type": "Education",
      "poi_address": "5110 E Lafayette Blvd, Phoenix, AZ 85018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-8059-7639-9d0c-c0ad3f8cd0a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-8059-7639-9d0c-c0ad3f8cd0a5",
        "storage_key": "property/6767906449166801/019d02d1-8059-7639-9d0c-c0ad3f8cd0a5.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "https://hopi.susd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13369421128604517229&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hopi-elementary-school",
      "poi_latitude": "33.497074",
      "poi_longitude": "-111.9698428",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-484-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e295-73be-8273-42fdbf41b297",
        "storage_key": "property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI2o2dGYMK4cRbQMTp665ibk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_0e368a92-bc68-4fc7-80ac-d090ca10c9dc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "St. Theresa Catholic School",
      "poi_type": "Education",
      "poi_address": "5001 E Thomas Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-8167-7468-b63f-05e21abc8935.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-8167-7468-b63f-05e21abc8935",
        "storage_key": "property/6767906449166801/019d02d1-8167-7468-b63f-05e21abc8935.webp",
        "width": 1024,
        "height": 650
      },
      "poi_business_url": "http://www.stcs.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6113282372601069259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-theresa-catholic-school",
      "poi_latitude": "33.4791597",
      "poi_longitude": "-111.9735121",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 602-840-0010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e295-73be-8273-42fdbf41b297",
        "storage_key": "property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6wKRthUMK4cRyz6Lpu291lQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_eca7c27a-816d-43bd-a58e-4c27aaec2ae2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Echo Canyon School",
      "poi_type": "Education",
      "poi_address": "4330 N 62nd St, Scottsdale, AZ 85251, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-8266-716e-9440-d73508db5bfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-8266-716e-9440-d73508db5bfc",
        "storage_key": "property/6767906449166801/019d02d1-8266-716e-9440-d73508db5bfc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://echocanyon.susd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6004059998602455995&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "echo-canyon-school",
      "poi_latitude": "33.4998079",
      "poi_longitude": "-111.9479771",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-484-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e295-73be-8273-42fdbf41b297",
        "storage_key": "property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb3JsH4YLK4cRu-vUAsK0UlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e6e4653b-310d-4746-85db-46e8006ab1fb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "New Way Academy",
      "poi_type": "Education",
      "poi_address": "5048 E Oak St, Phoenix, AZ 85008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-81b1-77f4-9475-e585ed84aa98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-81b1-77f4-9475-e585ed84aa98",
        "storage_key": "property/6767906449166801/019d02d1-81b1-77f4-9475-e585ed84aa98.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://newwayacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5880431880807543320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-way-academy",
      "poi_latitude": "33.4730442",
      "poi_longitude": "-111.9726031",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 602-389-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e295-73be-8273-42fdbf41b297",
        "storage_key": "property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLVU00RkMK4cRGHJqxaN9m1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_de1b0701-4683-436e-94b8-23f34ccc24c5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "GateWay Community College-Washington Campus",
      "poi_type": "Education",
      "poi_address": "108 N 40th St, Phoenix, AZ 85034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-8718-7551-b6f3-a12e5f0199f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-8718-7551-b6f3-a12e5f0199f3",
        "storage_key": "property/6767906449166801/019d02d1-8718-7551-b6f3-a12e5f0199f3.webp",
        "width": 843,
        "height": 403
      },
      "poi_business_url": "http://www.gatewaycc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8015991021544478560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gateway-community-college-washington-campus",
      "poi_latitude": "33.4498543",
      "poi_longitude": "-111.99837",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-286-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e295-73be-8273-42fdbf41b297",
        "storage_key": "property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8QF5IoYOK4cRYBfhEV2FPm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c4357fcc-7de0-4dac-87e6-30c7aa352234",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Arizona State University Tempe Campus",
      "poi_type": "Education",
      "poi_address": "1151 S Forest Ave, Tempe, AZ, USA",
      "poi_short_description": "Big public university known for its athletics programs, multiple campuses & its research facilities.",
      "poi_long_description": "Big public university known for its athletics programs, multiple campuses & its research facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-88a5-717b-9c50-59826d317185.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-88a5-717b-9c50-59826d317185",
        "storage_key": "property/6767906449166801/019d02d1-88a5-717b-9c50-59826d317185.webp",
        "width": 1280,
        "height": 1113
      },
      "poi_business_url": "https://asu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7380961630776733747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arizona-state-university-tempe-campus",
      "poi_latitude": "33.4229975",
      "poi_longitude": "-111.9278306",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 855-278-5080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e295-73be-8273-42fdbf41b297",
        "storage_key": "property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD1QzO9sIK4cRMzA8R39xbmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2ad158f8-2bfa-40d9-a2bf-076580bf7145",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Phoenix Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "1625 N Central Ave, Phoenix, AZ 85004, USA",
      "poi_short_description": "Expansive collection of acclaimed international art from the distant past to the present.",
      "poi_long_description": "Expansive collection of acclaimed international art from the distant past to the present.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-8993-705a-82bc-7fb32e2a02ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-8993-705a-82bc-7fb32e2a02ea",
        "storage_key": "property/6767906449166801/019d02d1-8993-705a-82bc-7fb32e2a02ea.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://phxart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9100201502871915249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-art-museum",
      "poi_latitude": "33.4670863",
      "poi_longitude": "-112.0727721",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-257-1880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e27d-735f-9433-ed6ce837940d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e27d-735f-9433-ed6ce837940d",
        "storage_key": "property/6767906449166801/019d02d1-e27d-735f-9433-ed6ce837940d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmcBGT0ASK4cR8QooSw1pSn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_911716cf-1bbb-432c-83a7-9fc01be65941",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Heard Museum",
      "poi_type": "Entertainment",
      "poi_address": "2301 N Central Ave, Phoenix, AZ 85004, USA",
      "poi_short_description": "Exhibits devoted to Native American  civilizations, including a big collection of Southwestern art.",
      "poi_long_description": "Exhibits devoted to Native American  civilizations, including a big collection of Southwestern art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-8b73-77ad-9b4d-7c3037834e77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-8b73-77ad-9b4d-7c3037834e77",
        "storage_key": "property/6767906449166801/019d02d1-8b73-77ad-9b4d-7c3037834e77.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://heard.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15873792203703506722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heard-museum",
      "poi_latitude": "33.4725814",
      "poi_longitude": "-112.0722331",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-252-8840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e27d-735f-9433-ed6ce837940d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e27d-735f-9433-ed6ce837940d",
        "storage_key": "property/6767906449166801/019d02d1-e27d-735f-9433-ed6ce837940d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq1ARW0ISK4cRItccBOgJS9w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_781da575-2acc-48c8-ba51-61cf53ce9ea6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Arizona Science Center",
      "poi_type": "Entertainment",
      "poi_address": "600 E Washington St, Phoenix, AZ 85004, USA",
      "poi_short_description": "Science comes alive in this 4-story hands-on arena with live demos, a planetarium & an IMAX theater.",
      "poi_long_description": "Science comes alive in this 4-story hands-on arena with live demos, a planetarium & an IMAX theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-8e13-747c-99d6-83630962e06e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-8e13-747c-99d6-83630962e06e",
        "storage_key": "property/6767906449166801/019d02d1-8e13-747c-99d6-83630962e06e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://azscience.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17330222221209878489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arizona-science-center",
      "poi_latitude": "33.4489422",
      "poi_longitude": "-112.0662283",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-716-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e27d-735f-9433-ed6ce837940d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e27d-735f-9433-ed6ce837940d",
        "storage_key": "property/6767906449166801/019d02d1-e27d-735f-9433-ed6ce837940d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLRHTlB4SK4cR2b_LbUpRgfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_93d8ef5c-dd3b-4fdf-9270-22b85361d452",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Orpheum Theatre Phoenix",
      "poi_type": "Entertainment",
      "poi_address": "203 W Adams St, Phoenix, AZ 85003, USA",
      "poi_short_description": "Renovated beaux arts-style setting for live performances, with 2 balconies & seating for over 1,300.",
      "poi_long_description": "Renovated beaux arts-style setting for live performances, with 2 balconies & seating for over 1,300.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-90e8-7122-a64a-2f6aa7d42056.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-90e8-7122-a64a-2f6aa7d42056",
        "storage_key": "property/6767906449166801/019d02d1-90e8-7122-a64a-2f6aa7d42056.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://orpheumphx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5819869306526232308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orpheum-theatre-phoenix",
      "poi_latitude": "33.4491561",
      "poi_longitude": "-112.0766533",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-262-6225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJucUk5SMSK4cR9O6xnkxUxFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_0de9e1fb-99bc-4d2f-88c3-610f6d2e9d44",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "The Van Buren",
      "poi_type": "Entertainment",
      "poi_address": "401 W Van Buren St, Phoenix, AZ 85003, USA",
      "poi_short_description": "Intimate venue for concerts, DJs and stand-up shows, featuring a balcony and a patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-912e-734b-b9ec-b7a59a6af47a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-912e-734b-b9ec-b7a59a6af47a",
        "storage_key": "property/6767906449166801/019d02d1-912e-734b-b9ec-b7a59a6af47a.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.thevanburenphx.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=12264220938019019973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-van-buren",
      "poi_latitude": "33.4512811",
      "poi_longitude": "-112.0792443",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 480-659-1641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU9Np9CQSK4cRxRyI6fZDM6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_5e48ff5d-73a6-48f9-bec2-a8bb30b25ba4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Crescent Ballroom",
      "poi_type": "Entertainment",
      "poi_address": "308 N 2nd Ave, Phoenix, AZ 85003, USA",
      "poi_short_description": "Former garage turned concert venue and tavern that also features a restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-929b-709c-8792-f8388a0342cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-929b-709c-8792-f8388a0342cc",
        "storage_key": "property/6767906449166801/019d02d1-929b-709c-8792-f8388a0342cc.webp",
        "width": 744,
        "height": 744
      },
      "poi_business_url": "https://www.crescentphx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11297791727930337574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crescent-ballroom",
      "poi_latitude": "33.4517982",
      "poi_longitude": "-112.0768576",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyxk3cSMSK4cRJmmi4bfRyZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_9d717cdf-4525-40b3-a78c-24ca2ebe901e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Harkins Theatres Camelview at Fashion Square 14",
      "poi_type": "Entertainment",
      "poi_address": "7014 E Camelback Rd, Scottsdale, AZ 85251, USA",
      "poi_short_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_long_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-9912-7156-bfd6-d7139c0c2522.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-9912-7156-bfd6-d7139c0c2522",
        "storage_key": "property/6767906449166801/019d02d1-9912-7156-bfd6-d7139c0c2522.webp",
        "width": 1280,
        "height": 881
      },
      "poi_business_url": "https://www.harkins.com/theatres/camelview-at-fashion-sq?utm_source=google&utm_medium=local&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17039917804045756216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harkins-theatres-camelview-at-fashion-square-14",
      "poi_latitude": "33.5045461",
      "poi_longitude": "-111.9274248",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-947-8778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e86b-7051-88d7-9ce5841005c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e86b-7051-88d7-9ce5841005c3",
        "storage_key": "property/6767906449166801/019d02d1-e86b-7051-88d7-9ce5841005c3.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxKfvqILK4cROGcAIPbyeew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_2bfa1ef1-82c7-4f1c-8de3-3f88eab44529",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Musical Instrument Museum",
      "poi_type": "Entertainment",
      "poi_address": "4725 E Mayo Blvd, Phoenix, AZ 85050, USA",
      "poi_short_description": "Expansive display of instruments from roughly 200 countries, including some that guests can try out.",
      "poi_long_description": "Expansive display of instruments from roughly 200 countries, including some that guests can try out.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-9949-72df-ac00-83f3db4066b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-9949-72df-ac00-83f3db4066b9",
        "storage_key": "property/6767906449166801/019d02d1-9949-72df-ac00-83f3db4066b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mim.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3729350831455392251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "musical-instrument-museum",
      "poi_latitude": "33.6679904",
      "poi_longitude": "-111.9782969",
      "poi_miles_from_property": "14.2",
      "poi_walking_minutes": "5 hours 18 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 480-478-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e27d-735f-9433-ed6ce837940d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e27d-735f-9433-ed6ce837940d",
        "storage_key": "property/6767906449166801/019d02d1-e27d-735f-9433-ed6ce837940d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJfTp55hhxK4cR-9G0f9JQwTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_598d5a78-d926-4eef-8a6a-8ba2a0a2e172",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Banner - University Medical Center Phoenix",
      "poi_type": "Health and Wellness",
      "poi_address": "1111 E McDowell Rd, Phoenix, AZ 85006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-9bdb-752c-bd35-4bc3429cc6ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-9bdb-752c-bd35-4bc3429cc6ce",
        "storage_key": "property/6767906449166801/019d02d1-9bdb-752c-bd35-4bc3429cc6ce.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/phoenix/banner-university-medical-center-phoenix?y_source=1_MTE5MDczNTMtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=5784332207521473033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "banner---university-medical-center-phoenix",
      "poi_latitude": "33.4645644",
      "poi_longitude": "-112.0573664",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-839-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e8a5-763f-9ebf-04374368305e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e8a5-763f-9ebf-04374368305e",
        "storage_key": "property/6767906449166801/019d02d1-e8a5-763f-9ebf-04374368305e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoV6LoQ0SK4cRCSIr_H4TRlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9d011e84-b917-4671-ac00-5d6332c214f9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Mayo Clinic Hospital PHX-1",
      "poi_type": "Health and Wellness",
      "poi_address": "5777 E Mayo Blvd, Phoenix, AZ 85054, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-9dca-74ed-ad32-a50f660317c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-9dca-74ed-ad32-a50f660317c8",
        "storage_key": "property/6767906449166801/019d02d1-9dca-74ed-ad32-a50f660317c8.webp",
        "width": 707,
        "height": 398
      },
      "poi_business_url": "http://www.mayoclinic.org/patient-visitor-guide/arizona/campus-buildings-maps/mayo-clinic-hospital?mc_id=us&utm_source=yext&utm_medium=l&utm_content=feature&utm_campaign=mayoclinic&geo=national&placementsite=enterprise&invsrc=other&cauid=102372&y_source=1_MzkxODQ3MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3974166919252800114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mayo-clinic-hospital-phx-1",
      "poi_latitude": "33.6594309",
      "poi_longitude": "-111.9563162",
      "poi_miles_from_property": "14.3",
      "poi_walking_minutes": "5 hours 20 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 480-342-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e8a5-763f-9ebf-04374368305e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e8a5-763f-9ebf-04374368305e",
        "storage_key": "property/6767906449166801/019d02d1-e8a5-763f-9ebf-04374368305e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJUV5hvjVxK4cRcvIrzMETJzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_026b66ce-c581-43e7-9214-f8cbd4c750cb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "NextCare Urgent Care Phoenix - E. Indian School Road",
      "poi_type": "Health and Wellness",
      "poi_address": "4730 E Indian School Rd #211, Phoenix, AZ 85018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-a08b-7562-910f-f80d7d1e2763.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-a08b-7562-910f-f80d7d1e2763",
        "storage_key": "property/6767906449166801/019d02d1-a08b-7562-910f-f80d7d1e2763.webp",
        "width": 1280,
        "height": 875
      },
      "poi_business_url": "https://nextcare.com/locations/az/phoenix-e-indian-school-rd/?utm_source=google&utm_medium=organic&utm_campaign=google_maps&utm_content=arcadia",
      "poi_directions_map_url": "https://maps.google.com/?cid=10174068875405506386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nextcare-urgent-care-phoenix---e-indian-school-road",
      "poi_latitude": "33.4950885",
      "poi_longitude": "-111.979851",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-354-3491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0dk36lwMK4cRUjfn1ryNMY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_73f8b88c-4784-479a-b93c-bf84c56cb7fc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "MinuteClinic at CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "4742 E Indian School Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-a0a3-75fb-bb08-3ec4a7a4198f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-a0a3-75fb-bb08-3ec4a7a4198f",
        "storage_key": "property/6767906449166801/019d02d1-a0a3-75fb-bb08-3ec4a7a4198f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.cvs.com/minuteclinic/clinic-locator/az/phoenix/9202.html?WT.mc_id=LS_mc_google_carenav_9202",
      "poi_directions_map_url": "https://maps.google.com/?cid=7364685419221978910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minuteclinic-at-cvs",
      "poi_latitude": "33.4959544",
      "poi_longitude": "-111.9786115",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 866-389-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqyIi3lwMK4cRHo85d16eNGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_2c97d766-43b0-4753-a208-f6bd7f93a8ea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "4134 N 44th St, Phoenix, AZ 85018, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-a2c7-7298-b864-d595224c0661.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-a2c7-7298-b864-d595224c0661",
        "storage_key": "property/6767906449166801/019d02d1-a2c7-7298-b864-d595224c0661.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4134+n+44th+st-phoenix-az-85018/id=5938",
      "poi_directions_map_url": "https://maps.google.com/?cid=7299134291086373546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.49587959999999",
      "poi_longitude": "-111.9874728",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-954-9119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK0sBbVoMK4cRqnITHPe7S2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_4f466eac-615d-4f18-bb24-d8a3aa2725d4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Camelback Village Racquet & Health Club",
      "poi_type": "Health and Wellness",
      "poi_address": "4444 E Camelback Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Family-friendly fitness center with tennis courts, swimming pools, saunas, hot yoga classes and massages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-a479-730d-9ec3-ccb50152b47b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-a479-730d-9ec3-ccb50152b47b",
        "storage_key": "property/6767906449166801/019d02d1-a479-730d-9ec3-ccb50152b47b.webp",
        "width": 1280,
        "height": 782
      },
      "poi_business_url": "http://villageclubs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4528808818626534166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camelback-village-racquet--health-club",
      "poi_latitude": "33.5106846",
      "poi_longitude": "-111.9846544",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-840-6412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi7xgQ_EMK4cRFhvkOaCP2T4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_ac839437-efa6-4426-90fc-4ad81811a6ae",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "The Foundry Arcadia",
      "poi_type": "Health and Wellness",
      "poi_address": "4730 E Indian School Rd #207a, Phoenix, AZ 85018, USA",
      "poi_short_description": "Yoga studio offering hot yoga, barre, Pilates, and HIIT in Arcadia Town Center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-a87f-75ef-99d7-2d20db7f9be3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-a87f-75ef-99d7-2d20db7f9be3",
        "storage_key": "property/6767906449166801/019d02d1-a87f-75ef-99d7-2d20db7f9be3.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "https://thefoundryyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14113638085387758421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-foundry-arcadia",
      "poi_latitude": "33.494909",
      "poi_longitude": "-111.979804",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-675-0842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e295-73be-8273-42fdbf41b297",
        "storage_key": "property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0Yiq-bcLK4cRVSv2tw-33cM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_2dbe5973-203f-4b18-8df9-3b7e9658ff9e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "3750 E Indian School Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-a83c-77cf-b548-0acf94784312.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-a83c-77cf-b548-0acf94784312",
        "storage_key": "property/6767906449166801/019d02d1-a83c-77cf-b548-0acf94784312.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/arcadia/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=9911095787312364938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "33.4957526",
      "poi_longitude": "-112.0000832",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-372-4692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e295-73be-8273-42fdbf41b297",
        "storage_key": "property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmZzPT6sNK4cRir2feRtJi4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_00943ae4-4626-4014-90f0-6e1ef91e1993",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "radi8 HOT YOGA",
      "poi_type": "Health and Wellness",
      "poi_address": "3950 E Indian School Rd #110, Phoenix, AZ 85018, USA",
      "poi_short_description": "Studio with heated rooms for hot yoga classes, also selling clothing and accessories.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-aa8e-7493-8299-fb2f3830abac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-aa8e-7493-8299-fb2f3830abac",
        "storage_key": "property/6767906449166801/019d02d1-aa8e-7493-8299-fb2f3830abac.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.radi8love.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6217510946184580452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "radi8-hot-yoga",
      "poi_latitude": "33.495335",
      "poi_longitude": "-111.9961111",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-888-2288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e295-73be-8273-42fdbf41b297",
        "storage_key": "property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUzO4jVMMK4cRZE1vhkMJSVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_9abae197-a769-4381-852f-5f917a5a3c77",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "4219 E Indian School Rd #101, Phoenix, AZ 85018, USA",
      "poi_short_description": "Ballet-inspired studio offering low-impact, high-intensity, full-body workouts for various fitness levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-ab2d-76d3-81fc-f6f6c5bf2dba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-ab2d-76d3-81fc-f6f6c5bf2dba",
        "storage_key": "property/6767906449166801/019d02d1-ab2d-76d3-81fc-f6f6c5bf2dba.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/phoenix-az",
      "poi_directions_map_url": "https://maps.google.com/?cid=4021718281322137073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "33.4947411",
      "poi_longitude": "-111.9903337",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-840-6140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Y7M71AMK4cR8YXmCHgD0Dc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_5732713d-c77c-49be-8793-97db3afb692c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Pierce Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2150 N 46th St, Phoenix, AZ 85008, USA",
      "poi_short_description": "Lighted courts & fields for basketball, tennis, softball, volleyball, plus a playground & restrooms.",
      "poi_long_description": "Lighted courts & fields for basketball, tennis, softball, volleyball, plus a playground & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-af45-779e-a4f0-ac15e3f2cd39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-af45-779e-a4f0-ac15e3f2cd39",
        "storage_key": "property/6767906449166801/019d02d1-af45-779e-a4f0-ac15e3f2cd39.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.phoenix.gov/parks/parks/alphabetical/p-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=2380149822699428772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pierce-park",
      "poi_latitude": "33.4709897",
      "poi_longitude": "-111.9838718",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 602-262-6696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e833-7264-925f-94033adc27fe",
        "storage_key": "property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ_oHyyQMK4cRpFs1Nqf9ByE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cad5f755-e91e-4b00-a5ba-c97e9382083d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "G.R. Herberger Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5802 E Indian School Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Green space featuring tennis and pickleball courts, plus bike trails and a waterfall.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-b022-7420-83b9-db15bcfb9d31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-b022-7420-83b9-db15bcfb9d31",
        "storage_key": "property/6767906449166801/019d02d1-b022-7420-83b9-db15bcfb9d31.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.phoenix.gov/parks/parks/alphabetical/h-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=5882816214843196013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gr-herberger-park",
      "poi_latitude": "33.490798",
      "poi_longitude": "-111.9566635",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-262-6696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e833-7264-925f-94033adc27fe",
        "storage_key": "property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQWLQ3QMK4cRbQKjzC32o1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b2b1bd03-4322-47be-b221-dbcd4e4c4415",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Kachina Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4304 E Campbell Ave, Phoenix, AZ 85018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-b1bb-712f-a8fd-a62826c23c66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-b1bb-712f-a8fd-a62826c23c66",
        "storage_key": "property/6767906449166801/019d02d1-b1bb-712f-a8fd-a62826c23c66.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/parks/alphabetical/k-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=15571614536231403965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kachina-park",
      "poi_latitude": "33.5026666",
      "poi_longitude": "-111.9903434",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-262-6696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e833-7264-925f-94033adc27fe",
        "storage_key": "property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG7jvIXMMK4cRvcFhM-t8Gdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7d95d0aa-aede-4408-84d7-0c736a92379a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Arcadia Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3402 N 56th St, Phoenix, AZ 85018, USA",
      "poi_short_description": "Open space featuring a sizable playground, plus a grassy area, picnic tables & a volleyball court.",
      "poi_long_description": "Open space featuring a sizable playground, plus a grassy area, picnic tables & a volleyball court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-b37e-743b-9cf9-b6472e4411de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-b37e-743b-9cf9-b6472e4411de",
        "storage_key": "property/6767906449166801/019d02d1-b37e-743b-9cf9-b6472e4411de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11815537359772007291&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arcadia-park",
      "poi_latitude": "33.4881912",
      "poi_longitude": "-111.9623252",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-256-3220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e833-7264-925f-94033adc27fe",
        "storage_key": "property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6Pz9nIMK4cRezuRl6A4-aM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_664ef0b7-dad0-4c7e-884c-bb172980ab78",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Desert Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1201 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "Desert garden with 50,000 plants spread over 140 acres, also offering dining, a gift shop & library.",
      "poi_long_description": "Desert garden with 50,000 plants spread over 140 acres, also offering dining, a gift shop & library.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-97b3-77c7-9b4d-40606291000d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-97b3-77c7-9b4d-40606291000d",
        "storage_key": "property/6767906449166801/019d02d1-97b3-77c7-9b4d-40606291000d.webp",
        "width": 638,
        "height": 481
      },
      "poi_business_url": "https://dbg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2404053162249248023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "desert-botanical-garden",
      "poi_latitude": "33.4616795",
      "poi_longitude": "-111.944926",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-941-1225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e833-7264-925f-94033adc27fe",
        "storage_key": "property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZ4tCFMJK4cRF10FJZ3pXCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_c22ae935-e204-43e5-bb05-1eece664f7be",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Phoenix Zoo",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "455 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "125 acres of animal exhibits, including a children's area & petting zoo, plus a narrated tram ride.",
      "poi_long_description": "125 acres of animal exhibits, including a children's area & petting zoo, plus a narrated tram ride.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-94ed-757c-ace6-b1bb8e98ab08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-94ed-757c-ace6-b1bb8e98ab08",
        "storage_key": "property/6767906449166801/019d02d1-94ed-757c-ace6-b1bb8e98ab08.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenixzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7252865776953727344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-zoo",
      "poi_latitude": "33.4500374",
      "poi_longitude": "-111.9470063",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-286-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ3texLIOK4cRcBnqLv9ap2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_5153b2a7-7720-4fa2-b21d-dcf68130882a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Hole in the Rock",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "Landmark rock formation with multiple cavelike holes in the sandstone created by erosion.",
      "poi_long_description": "Landmark rock formation with multiple cavelike holes in the sandstone created by erosion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-b83e-707b-8f5c-d054ff59c4f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-b83e-707b-8f5c-d054ff59c4f9",
        "storage_key": "property/6767906449166801/019d02d1-b83e-707b-8f5c-d054ff59c4f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/papago-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=385298564104506413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hole-in-the-rock",
      "poi_latitude": "33.4564869",
      "poi_longitude": "-111.9452606",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-495-5458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e833-7264-925f-94033adc27fe",
        "storage_key": "property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWuhyFEJK4cRLczqrQDbWAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_1c79546e-07ce-4cda-9ec8-0e7fe0269ddd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Echo Canyon Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "E McDonald Dr, Phoenix, AZ 85018, USA",
      "poi_short_description": "Trailhead featuring a parking lot, restrooms & the start of a trail leading up Camelback Mountain.",
      "poi_long_description": "Trailhead featuring a parking lot, restrooms & the start of a trail leading up Camelback Mountain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-b8c8-7418-b48f-d7e1e13ca642.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-b8c8-7418-b48f-d7e1e13ca642",
        "storage_key": "property/6767906449166801/019d02d1-b8c8-7418-b48f-d7e1e13ca642.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/administration/departments/parks/activities-facilities/trails/camelback-mountain/camelback-trails.html#echo-canyon-trailhead",
      "poi_directions_map_url": "https://maps.google.com/?cid=11691523250841911723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "echo-canyon-trailhead",
      "poi_latitude": "33.5213895",
      "poi_longitude": "-111.9735617",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e833-7264-925f-94033adc27fe",
        "storage_key": "property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpRaTg5QMK4cRqwGnyXOiQKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_4e659010-fa08-4113-8129-5e62308ef090",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Steele Indian School Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 E Indian School Rd, Phoenix, AZ 85012, USA",
      "poi_short_description": "Leafy lawned park around a lake with a playground, basketball & volleyball courts & picnic shelters.",
      "poi_long_description": "Leafy lawned park around a lake with a playground, basketball & volleyball courts & picnic shelters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-b9d0-75b6-8828-be302d08316b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-b9d0-75b6-8828-be302d08316b",
        "storage_key": "property/6767906449166801/019d02d1-b9d0-75b6-8828-be302d08316b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/parks/alphabetical/s-parks/steele-indian-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=15561299676862919800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "steele-indian-school-park",
      "poi_latitude": "33.5009135",
      "poi_longitude": "-112.0708073",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 602-495-0935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e833-7264-925f-94033adc27fe",
        "storage_key": "property/6767906449166801/019d02d1-e833-7264-925f-94033adc27fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcA-YY0SK4cReLTQ2pvX9Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0fc77fc2-8cd1-4a2d-b6f0-17dc2b3c323c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "44th St/Washington",
      "poi_type": "Transportation & Transit",
      "poi_address": "4299, 4399 E Washington St, Phoenix, AZ 85008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-bbeb-7608-a684-be1ef943a844.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-bbeb-7608-a684-be1ef943a844",
        "storage_key": "property/6767906449166801/019d02d1-bbeb-7608-a684-be1ef943a844.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.valleymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3393582418176576930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "44th-stwashington",
      "poi_latitude": "33.4481899",
      "poi_longitude": "-111.9879484",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 602-251-2039",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuS015I8OK4cRog1ttzptGC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_f2471a2e-7b37-4a90-8310-fbffdace5e5a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "44th St Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-c027-773c-b8c0-8e2e80f35655.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-c027-773c-b8c0-8e2e80f35655",
        "storage_key": "property/6767906449166801/019d02d1-c027-773c-b8c0-8e2e80f35655.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.skyharbor.com/PHXSkyTrain",
      "poi_directions_map_url": "https://maps.google.com/?cid=13752464089485512657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "44th-st-station",
      "poi_latitude": "33.4469408",
      "poi_longitude": "-111.990366",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNaqyu48OK4cR0Y8ZyDmR2r4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_2c27718a-b42a-4865-b415-9836b7b12c5c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "44th St & Indian School Rd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8013639424906817915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "44th-st--indian-school-rd",
      "poi_latitude": "33.4954524",
      "poi_longitude": "-111.9867556",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn6LVaFoMK4cRe_GiT5kqNm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_b11f5dba-d474-464b-aabd-99ba94e8ed02",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "44th St & Camelback Rd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-c11f-759f-901b-9c6929750c0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-c11f-759f-901b-9c6929750c0c",
        "storage_key": "property/6767906449166801/019d02d1-c11f-759f-901b-9c6929750c0c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10856006873341437063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "44th-st--camelback-rd",
      "poi_latitude": "33.5089613",
      "poi_longitude": "-111.986888",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ21O9ufAMK4cRhyS31LtIqJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_c2c22139-8293-4299-8f19-30669877e24f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Indian School/Central Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-c2dd-73f8-ac7e-225348c3bd27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-c2dd-73f8-ac7e-225348c3bd27",
        "storage_key": "property/6767906449166801/019d02d1-c2dd-73f8-ac7e-225348c3bd27.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=162540954658734140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-schoolcentral-ave",
      "poi_latitude": "33.49575",
      "poi_longitude": "-112.073789",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg1tq8PISK4cRPADjFyN2QQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_c5514c38-a8c7-4832-bf4e-ff6e5d980698",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Central & Camelback Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "169 W Camelback Rd, Phoenix, AZ 85013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-c529-7188-87aa-4ee254f6ce3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-c529-7188-87aa-4ee254f6ce3a",
        "storage_key": "property/6767906449166801/019d02d1-c529-7188-87aa-4ee254f6ce3a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.valleymetro.org/how-to-ride/park-and-ride/central-camelback-park-and-ride/169-w-camelback-rd",
      "poi_directions_map_url": "https://maps.google.com/?cid=9454735961150509972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central--camelback-park-and-ride",
      "poi_latitude": "33.5089254",
      "poi_longitude": "-112.0780386",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 602-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e9db-74fc-8d9a-8a0b7a8175c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e9db-74fc-8d9a-8a0b7a8175c3",
        "storage_key": "property/6767906449166801/019d02d1-e9db-74fc-8d9a-8a0b7a8175c3.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJuZMficESK4cRlNN8aUP4NYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_c13f2b15-eba6-4e30-b169-b6dc44182146",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "38th St/Washington",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-c7ed-77d5-831d-fc41de189f40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-c7ed-77d5-831d-fc41de189f40",
        "storage_key": "property/6767906449166801/019d02d1-c7ed-77d5-831d-fc41de189f40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=359039951505251555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "38th-stwashington",
      "poi_latitude": "33.448104",
      "poi_longitude": "-111.999896",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW4qC9YcOK4cR49ykAe-Q-wQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_1ab4b67a-3c26-46cd-83ee-ccc823ded642",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Phoenix Sky Harbor International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3400 Sky Hbr Blvd, Phoenix, AZ 85034, USA",
      "poi_short_description": "This 3,000-acre airport serving the Phoenix area  features rail service & a variety of artwork.",
      "poi_long_description": "This 3,000-acre airport serving the Phoenix area  features rail service & a variety of artwork.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-c82a-773b-81bf-95525aed83d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-c82a-773b-81bf-95525aed83d2",
        "storage_key": "property/6767906449166801/019d02d1-c82a-773b-81bf-95525aed83d2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.skyharbor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9436507786966396482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-sky-harbor-international-airport",
      "poi_latitude": "33.435249",
      "poi_longitude": "-112.010124",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 602-273-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-ee0f-7130-bb51-0e3dbe3a85b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ee0f-7130-bb51-0e3dbe3a85b4",
        "storage_key": "property/6767906449166801/019d02d1-ee0f-7130-bb51-0e3dbe3a85b4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXADM1wOK4cRQu5W4tU19YI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_8ae06c87-f159-4a4b-9a55-f60a47a76fc5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Freeport-McMoRan Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "333 N Central Ave Suite 500a, Phoenix, AZ 85004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-c9ec-7018-b01c-d9ff6797755a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-c9ec-7018-b01c-d9ff6797755a",
        "storage_key": "property/6767906449166801/019d02d1-c9ec-7018-b01c-d9ff6797755a.webp",
        "width": 855,
        "height": 1280
      },
      "poi_business_url": "http://www.fcx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6543649427783782269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freeport-mcmoran-inc",
      "poi_latitude": "33.451859",
      "poi_longitude": "-112.0726869",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-366-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc-kxXyISK4cRfY-9HXy2z1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1cecb10d-51f8-4e3d-93b0-a06242ab6a7a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Phoenix Children's Hospital - Thomas Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1919 E Thomas Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-ccc0-7187-8601-33e053a2ed7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-ccc0-7187-8601-33e053a2ed7d",
        "storage_key": "property/6767906449166801/019d02d1-ccc0-7187-8601-33e053a2ed7d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://phoenixchildrens.org/locations/Phoenix/1919-E-Thomas-Rd",
      "poi_directions_map_url": "https://maps.google.com/?cid=6808680874366999376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-childrens-hospital---thomas-campus",
      "poi_latitude": "33.4792497",
      "poi_longitude": "-112.0419475",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 602-933-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e8a5-763f-9ebf-04374368305e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e8a5-763f-9ebf-04374368305e",
        "storage_key": "property/6767906449166801/019d02d1-e8a5-763f-9ebf-04374368305e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJeVRSn_8NK4cRUBukaS5LfV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9fd8d02f-6fc3-4e8e-b393-39467adddfa7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "St. Joseph's Hospital and Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "350 W Thomas Rd, Phoenix, AZ 85013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-ce7b-742c-b365-b0ee25b84474.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-ce7b-742c-b365-b0ee25b84474",
        "storage_key": "property/6767906449166801/019d02d1-ce7b-742c-b365-b0ee25b84474.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://locations.dignityhealth.org/st-joseph's-hospital-and-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=16691754161655818328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-josephs-hospital-and-medical-center",
      "poi_latitude": "33.4820196",
      "poi_longitude": "-112.0790595",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 602-406-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e307-76ee-9638-731953158a00",
        "storage_key": "property/6767906449166801/019d02d1-e307-76ee-9638-731953158a00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZfUmGFkSK4cRWKikK_kFpec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_123906b8-5716-4b79-89a0-5492f4159861",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Carl T. Hayden Veterans' Administration Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "650 E Indian School Rd, Phoenix, AZ 85012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-cf0c-7787-ac04-8419a9a40aad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-cf0c-7787-ac04-8419a9a40aad",
        "storage_key": "property/6767906449166801/019d02d1-cf0c-7787-ac04-8419a9a40aad.webp",
        "width": 1280,
        "height": 802
      },
      "poi_business_url": "https://www.va.gov/phoenix-health-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18001601183389442107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carl-t-hayden-veterans-administration-medical-center",
      "poi_latitude": "33.49731",
      "poi_longitude": "-112.0668282",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 602-277-5551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e8a5-763f-9ebf-04374368305e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e8a5-763f-9ebf-04374368305e",
        "storage_key": "property/6767906449166801/019d02d1-e8a5-763f-9ebf-04374368305e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJlxLklI0SK4cRO-AtVOaI0vk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7970d79c-ef23-4539-b2d1-bf43a1ce755b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Arizona State University Downtown Phoenix Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "411 N Central Ave #400, Phoenix, AZ 85004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-d11c-71fd-b9d0-825194160a25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-d11c-71fd-b9d0-825194160a25",
        "storage_key": "property/6767906449166801/019d02d1-d11c-71fd-b9d0-825194160a25.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tours.asu.edu/downtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=10750644984180967322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arizona-state-university-downtown-phoenix-campus",
      "poi_latitude": "33.4538978",
      "poi_longitude": "-112.0706222",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-496-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e295-73be-8273-42fdbf41b297",
        "storage_key": "property/6767906449166801/019d02d1-e295-73be-8273-42fdbf41b297.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqY3-yCISK4cRmgdxXKf2MZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6dca47b2-486c-43e3-a4b9-e59e1ecf2fb1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Phoenix City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 W Washington St, Phoenix, AZ 85003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-d3e2-77e4-aea4-34c72a3667fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-d3e2-77e4-aea4-34c72a3667fa",
        "storage_key": "property/6767906449166801/019d02d1-d3e2-77e4-aea4-34c72a3667fa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.phoenix.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6171114499780558672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-city-hall",
      "poi_latitude": "33.4487244",
      "poi_longitude": "-112.0773405",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-262-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-ee94-72a1-bb77-7f6004e4b2b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ee94-72a1-bb77-7f6004e4b2b3",
        "storage_key": "property/6767906449166801/019d02d1-ee94-72a1-bb77-7f6004e4b2b3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTOCVyESK4cRUL-uC_EzpFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_5648b063-9a36-47f7-9b7f-95fd296a6259",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "custom",
      "poi_name": "Arizona Capitol Museum",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1700 W Washington St, Phoenix, AZ 85007, USA",
      "poi_short_description": "Restored circa-1901 capitol now offers a peek into old statehouse chambers & the governor's office.",
      "poi_long_description": "Restored circa-1901 capitol now offers a peek into old statehouse chambers & the governor's office.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-d6b8-77c8-b0b3-5fabb53b6a34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-d6b8-77c8-b0b3-5fabb53b6a34",
        "storage_key": "property/6767906449166801/019d02d1-d6b8-77c8-b0b3-5fabb53b6a34.webp",
        "width": 1103,
        "height": 1280
      },
      "poi_business_url": "https://azcapitolmuseum.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8369928824109305006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arizona-capitol-museum",
      "poi_latitude": "33.4480967",
      "poi_longitude": "-112.0970236",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-926-3620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d1-e27d-735f-9433-ed6ce837940d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e27d-735f-9433-ed6ce837940d",
        "storage_key": "property/6767906449166801/019d02d1-e27d-735f-9433-ed6ce837940d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZaHOni0SK4cRroxWdOv1J3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    }
  ],
  "office_hours": [
    {
      "id": "ec_43aae37cfa15e835fdf75e91",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_dcf228af3a4e68fba4d2b4e7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_41e45436b1e7ea8b3701b7df",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_07b1ed895c6a0af46b6de32c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b86fafa385ea8a0721bd2ef0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_a5be8aae-d13c-4a31-9f4a-fe5c297c5232",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "rating": "5.0",
      "name": "Matt Grand",
      "text": "Gianna was amazing but glad to see we have a new awesome manager Mirria, very nice and understanding, she was able to help me with a urgent issue that came up no problem. Also glad we have Gene here as well! Great community and neighbors-",
      "date": "2025-11-07",
      "title": ""
    },
    {
      "id": "custom_6f2f96cf-fdc6-4e75-8a2c-93a135fc3dbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "rating": "5.0",
      "name": "Strozier Amber",
      "text": "I've been living at Park Paloma for about 2 years this month and Gianna has always been amazing. She worked with me when I first moved and any time I need help or even to talk she is always there. She is very nice and makes sure I have all things and listens to my concerns. She keeps the community running. Truly an amazing Community Manager.\n\nGene is also great and super nice and makes sure all things are fixed in my place if I have an order to put in. Keeps the community looking good. Park Paloma is a great place to stay, small community but clean and nice.",
      "date": "2024-07-10",
      "title": ""
    },
    {
      "id": "custom_14d9f81f-3578-49a2-8955-9ef3cb048f5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "rating": "5.0",
      "name": "Aaron Jimenez",
      "text": "Mirria is great! She made the entire process easy for us and has a very friendly personality.",
      "date": "2025-12-12",
      "title": ""
    },
    {
      "id": "custom_44a6de91-b19d-4e11-a054-b52952b5a00a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "rating": "5.0",
      "name": "Vivian Robinson",
      "text": "I have lived at park Paloma for 3 1/2 years now and I must say Giana is the BEST manager we have ever had on site. She is timely with responses, she genuinely cares about everyone living there and is super helpful with anything I have needed. I recently moved into a renovated unit and she made the process so smooth and easy! I am so grateful to have someone who really cares about our community and I encourage anyone looking for an apt to talk to Giana!! She will get you set up 😇",
      "date": "2022-11-29",
      "title": ""
    },
    {
      "id": "custom_4d49be7a-cf6b-444a-b228-a6c8f3c5c9a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "rating": "5.0",
      "name": "lorin keith",
      "text": "A great community to live in! Gianna and gene are always so helpful whenever needed. Very spacious and clean apartments, quiet neighborhood & walkable area!",
      "date": "2025-04-07",
      "title": ""
    },
    {
      "id": "custom_8f336b80-c603-4b59-ae51-b5a4fd3b368a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "rating": "5",
      "name": "Kimberly",
      "text": "I’ve had a really good experience living here, and I especially want to give a shoutout to Jonathan. I see him around the property pretty often, always walking around and making sure everything looks clean, nice, and well taken care of. You can tell he really puts effort into keeping the community looking its best.\nHe’s also been really helpful whenever I’ve had questions or needed anything. He’s friendly, approachable, and always willing to help. I really appreciate the time and effort he puts into keeping the property looking its best and making residents feel taken care of. Definitely grateful to have a property manager like Jonathan!",
      "date": "2026-09-27",
      "title": "false"
    },
    {
      "id": "custom_df3fc465-f2c3-4e6b-a01f-60358dc035ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "rating": "5",
      "name": "Molly Grey",
      "text": "I’ve had a great experience at Park Paloma Apartments so far! The community is beautiful, the property is well maintained, and the overall atmosphere has been really welcoming.\n\nI also want to give a special shoutout to Jonathan, the manager. He has been incredibly helpful, professional, and easy to communicate with throughout the process. He genuinely takes the time to answer questions and make sure everything is taken care of. It’s refreshing to have a manager who is personable, responsive, and actually cares about the resident experience.\n\nI’m really happy with my decision to call Park Paloma home and would definitely recommend it to anyone looking for a great place to live!",
      "date": "2026-09-28",
      "title": "false"
    },
    {
      "id": "custom_64743aab-414b-4c46-99c9-56f4b03359b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "rating": "5",
      "name": " Evangelina Montoya",
      "text": "They are so friendly and very helpful and thanks! and also a very quiet place to call home 😁\n",
      "date": "2026-09-21",
      "title": "false"
    },
    {
      "id": "custom_be89ddd0-de5d-4cb9-9369-12baf684e5b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "rating": "5",
      "name": "Jasmine A",
      "text": "Love my community, my apartment is so cute and the staff is so helpful. Thank you Jonathan 🙂",
      "date": "2026-09-20",
      "title": "false"
    },
    {
      "id": "custom_c61e25c5-c652-410b-b8eb-3ad534878506",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "rating": "5",
      "name": "Gloria Rodriguez",
      "text": "Jonathan was very helpful, professional, and friendly.\n",
      "date": "2026-06-05",
      "title": "false"
    },
    {
      "id": "custom_bf77697c-5e40-45e7-96a6-95c60aad3054",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "rating": "5",
      "name": "P S",
      "text": "I had the opportunity to meet the new manager, Jonathan, and I really appreciated his professionalism and approachable attitude. He handled my situation calmly and with kindness, which made the experience very positive. Thank you!\n",
      "date": "2026-06-03",
      "title": "false"
    },
    {
      "id": "custom_750f98cd-ffd8-47b5-a2bb-6ef9d86976df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "rating": "5",
      "name": "Aaron Jimenez",
      "text": "Mirria is great! She made the entire process easy for us and has a very friendly personality.\n",
      "date": "2026-01-05",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_a82f07f9de07feaa0ff1719d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Park Paloma Apartments (602) 840-0590.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d2-d6dd-72bd-b4dc-2cacb8aedffb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Park Paloma Apartment Homes monument sign with address 2930.",
        "public_id": "019d02d2-d6dd-72bd-b4dc-2cacb8aedffb",
        "storage_key": "property/6767906449166801/019d02d2-d6dd-72bd-b4dc-2cacb8aedffb.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Park Paloma Apartments",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Fe39kMkCwpW"
    },
    {
      "id": "ec_48f59fd264096db789d1cb8e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Park Paloma Apartments.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d2-d6e0-7792-ac36-98348ece8e89.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living room with white sectional sofa, coffee table, bookshelf, and TV.",
        "public_id": "019d02d2-d6e0-7792-ac36-98348ece8e89",
        "storage_key": "property/6767906449166801/019d02d2-d6e0-7792-ac36-98348ece8e89.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1 Bedroom 1 Bathroom - 760 sq ft",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=fVSVeWZfnLN"
    },
    {
      "id": "ec_032d40086d9d2885a78800fc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Park Paloma Apartments.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d2-d6e0-7792-ac36-948d3f167fa7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Empty apartment living room with wood-look flooring and a glimpse of the kitchen.",
        "public_id": "019d02d2-d6e0-7792-ac36-948d3f167fa7",
        "storage_key": "property/6767906449166801/019d02d2-d6e0-7792-ac36-948d3f167fa7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2 Bedroom 2 Bathroom - 980 sq ft",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3Km5Nh12F8v"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019c05c1-3248-7498-ac88-16e088e5b901",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-park-paloma",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-phoenix-az-park-paloma",
      "search_query": "dog friendly apartments Phoenix AZ",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Phoenix, AZ",
      "h2_subtitle": "Discover pet-friendly living in Phoenix, AZ at Park Paloma. Enjoy spacious living with a dedicated bark park for your furry friends.",
      "page_copy": "Welcome to Park Paloma, the ultimate destination for those seeking dog-friendly apartments in Phoenix, AZ. Nestled in the vibrant Camelback East Village, our community offers ample spaces for you and your canine companions. Our on-site bark park makes it easy for your dogs to play and socialize, while you relax in the comfort of our modern amenities. \n\nAt Park Paloma, you can choose from one and two-bedroom floor plans, each featuring gourmet kitchens and expansive walk-in closets. Our pet-friendly community ensures that both you and your furry friend enjoy a comfortable and enjoyable lifestyle. Plus, with maintenance and package services, life at Park Paloma is hassle-free. Discover the perfect blend of comfort and convenience in the heart of Phoenix.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Phoenix, AZ",
      "seo_description": "Find dog-friendly apartments in Phoenix, AZ at Park Paloma. Enjoy pet amenities like an on-site bark park. Call us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "apartments-with-pool-camelback-east-village",
      "search_query": "apartments with pool in Camelback East Village",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Camelback East Village",
      "h2_subtitle": "Experience resort-style living in Camelback East Village. Our Phoenix community offers a relaxing pool and vibrant amenities.",
      "page_copy": "Park Paloma in Camelback East Village offers an array of amenities, including soothing swimming facilities perfect for relaxation. If you're searching for apartments with a pool in the vibrant Camelback East Village, our community provides the perfect setting for leisurely afternoons by the water.\n\nChoose from our one and two-bedroom floor plans at Park Paloma, each thoughtfully designed to cater to your lifestyle needs. Enjoy gourmet kitchens, spacious walk-in closets, and other luxurious comforts. With a focus on convenience and style, our community features additional perks, such as gas barbeque grills and a pet-friendly bark park, enhancing your living experience right in the heart of Phoenix.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Camelback East Village",
      "seo_description": "Discover Park Paloma's Phoenix apartments with a pool in Camelback East Village. Enjoy resort-style amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-maricopa-county",
      "search_query": "in unit laundry apartments Maricopa County",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Maricopa County",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry at Park Paloma. Discover premium living in Maricopa County, Phoenix.",
      "page_copy": "Searching for in-unit laundry apartments in Maricopa County? Look no further than Park Paloma, where convenience meets luxury. Nestled in the vibrant Camelback East Village of Phoenix, our community is designed for modern living with spacious floor plans that cater to all your needs. \n\nAt Park Paloma, enjoy the comfort of our one and two-bedroom apartments featuring amenities like gourmet kitchens and expansive walk-in closets. Whether unwinding by the pool or engaging in fun activities at our pet-friendly bark park, everything you need is right here. Experience the ultimate in convenience and style, all within the bustling heart of Maricopa County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Maricopa County",
      "seo_description": "Discover Park Paloma's in-unit laundry apartments in Maricopa County, Phoenix. Enjoy premium amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "quartz-countertops-luxury-apartments-85018",
      "search_query": "quartz countertops luxury apartments 85018",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Quartz Countertops in 85018",
      "h2_subtitle": "Experience elegance with quartz countertops at Park Paloma. Discover luxurious living in the heart of Phoenix, AZ 85018.",
      "page_copy": "Step into the world of luxury at Park Paloma, located in the desirable zip code of 85018, where quartz countertops set the standard for elegance. Our luxury apartments are tailored to offer a sophisticated living experience in the vibrant neighborhood of Camelback East Village.\n\nChoose from our meticulously designed one and two-bedroom floor plans, all featuring high-end finishes like quartz countertops. Enjoy additional amenities, including spacious walk-in closets, a relaxing spa, and a pet-friendly environment. At Park Paloma, luxury, comfort, and convenience are seamlessly blended to create your ideal Phoenix lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Quartz Countertops in 85018",
      "seo_description": "Discover Park Paloma's luxury apartments with quartz countertops in Phoenix, AZ 85018. Experience elegance and premium living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-near-phoenix",
      "search_query": "fitness center apartments near Phoenix",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center Near Phoenix",
      "h2_subtitle": "Stay fit and active at Park Paloma, featuring a convenient fitness center. Discover your ideal apartment near Phoenix today.",
      "page_copy": "Discover the ultimate in active living at Park Paloma, where apartments with a fitness center near Phoenix await you. Perfectly situated in Camelback East Village, our community provides everything you need to maintain a healthy lifestyle right at your doorstep.\n\nOur thoughtfully designed one and two-bedroom floor plans are complemented by premium amenities, including a well-equipped fitness center, spacious walk-in closets, and resort-style pool. Enjoy the best of Phoenix living with easy access to the city’s dynamic lifestyle. Whether you're relaxing or breaking a sweat, Park Paloma offers the perfect environment to thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center Near Phoenix",
      "seo_description": "Discover Park Paloma's Phoenix-area apartments with a fitness center, offering premium amenities and easy city access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-camelback-east-village",
      "search_query": "one bedroom apartments in Camelback East Village",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Camelback East Village",
      "h2_subtitle": "Find your perfect one-bedroom apartment at Park Paloma. Enjoy comfortable living in Camelback East Village, Phoenix.",
      "page_copy": "Looking for one-bedroom apartments in Camelback East Village? Welcome to Park Paloma, where comfort meets style in the heart of Phoenix. Our one-bedroom apartments offer thoughtfully designed spaces that are perfect for any lifestyle.\n\nAt Park Paloma, you will enjoy luxurious amenities such as spacious walk-in closets, gourmet kitchens, and a lively clubhouse. Nestled in the vibrant Camelback East Village, our community is ideally situated for accessing all the attractions Phoenix has to offer. Make your move today and start enjoying life in one of our exquisite one-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Camelback East Village",
      "seo_description": "Discover stylish one-bedroom apartments at Park Paloma in Camelback East Village, Phoenix, with spacious layouts and exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-maricopa-county",
      "search_query": "two bedroom apartments in Maricopa County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Maricopa County",
      "h2_subtitle": "Explore spacious two-bedroom apartments at Park Paloma, located in the heart of Maricopa County.",
      "page_copy": "Welcome to Park Paloma, where our two-bedroom apartments in Maricopa County offer both space and style. Situated conveniently in Phoenix's Camelback East Village, these apartments are perfect for families, roommates, or anyone needing a bit more room.\n\nEach two-bedroom apartment includes modern features such as gourmet kitchens, spacious walk-in closets, and access to on-site amenities like our relaxing spa and vibrant clubhouse. Located in the lively community of Maricopa County, Park Paloma seamlessly blends comfortable living with an ideal location, providing easy access to all Phoenix has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Maricopa County",
      "seo_description": "Discover two-bedroom apartments at Park Paloma in Maricopa County, offering spacious living with modern amenities in Phoenix.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "apartments-near-tavan-elementary-school-phoenix",
      "search_query": "apartments near Tavan Elementary School Phoenix",
      "category": "School",
      "h1_title": "Apartments Near Tavan Elementary School",
      "h2_subtitle": "Find ideal living at Park Paloma, near Tavan Elementary School in Phoenix. Enjoy family-friendly amenities and more.",
      "page_copy": "Searching for apartments near Tavan Elementary School in Phoenix? Park Paloma offers the perfect setting with its proximity to the school, making morning commutes a breeze. Our community not only provides convenience but also a welcoming environment ideal for families.\n\nChoose from our thoughtfully designed one and two-bedroom floor plans, featuring amenities like a pet-friendly bark park, spacious walk-in closets, and outdoor barbeque grills. Located in the charming Camelback East Village and within Maricopa County, Park Paloma places you close to educational resources and the best that Phoenix has to offer. Experience a comfortable lifestyle and community warmth at Park Paloma.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tavan Elementary School Phoenix",
      "seo_description": "Live near Tavan Elementary School at Park Paloma. Family-friendly apartments in Camelback East Village, Phoenix.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "park-paloma-close-to-ingleside-middle-school",
      "search_query": "Park Paloma close to Ingleside Middle School",
      "category": "School",
      "h1_title": "Park Paloma Near Ingleside Middle School",
      "h2_subtitle": "Discover Park Paloma, just minutes from Ingleside Middle School. Enjoy convenience and community-focused living in Phoenix.",
      "page_copy": "If you're looking for an ideal living option near Ingleside Middle School, consider Park Paloma. Located in the vibrant Camelback East Village in Phoenix, our community is perfect for families seeking proximity to top educational institutions like Ingleside Middle School.\n\nPark Paloma offers comfortable one and two-bedroom apartments equipped with modern amenities, including gourmet kitchens, spacious walk-in closets, and a pet-friendly bark park. With its prime Maricopa County location, residents can enjoy a seamless balance of convenience, comfort, and community-focused living. Choose Park Paloma and enjoy easy access to excellent schooling and a wonderful neighborhood atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma Near Ingleside Middle School",
      "seo_description": "Experience family-friendly living at Park Paloma, close to Ingleside Middle School, with top amenities in Phoenix.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "apartments-near-arcadia-high-school-85018",
      "search_query": "apartments near Arcadia High School 85018",
      "category": "School",
      "h1_title": "Apartments Near Arcadia High School 85018",
      "h2_subtitle": "Live conveniently at Park Paloma, near Arcadia High School in the 85018 area. Family-friendly amenities in a prime location.",
      "page_copy": "Located conveniently near Arcadia High School, Park Paloma provides an ideal setting for families seeking apartments within the 85018 zip code. Our community in Camelback East Village offers proximity to top educational institutions, making school commutes simple and stress-free.\n\nChoose from our selection of spacious one and two-bedroom floor plans, each equipped with modern amenities such as gourmet kitchens and walk-in closets. At Park Paloma, residents benefit from on-site features like a relaxing spa, a vibrant clubhouse, and a pet-friendly bark park. Experience the perfect blend of convenience and comfort in Maricopa County's prime residential area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Arcadia High School 85018",
      "seo_description": "Discover Park Paloma's family-friendly apartments near Arcadia High School in Phoenix's 85018 zip code.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "camelback-east-village-apartments-by-hopi-elementary-school",
      "search_query": "Camelback East Village apartments by Hopi Elementary School",
      "category": "School",
      "h1_title": "Camelback East Village Apartments by Hopi",
      "h2_subtitle": "Explore Park Paloma, nearby Hopi Elementary School in Camelback East Village. Enjoy family-focused living in Phoenix.",
      "page_copy": "If you're seeking apartments by Hopi Elementary School in Camelback East Village, Park Paloma is the perfect match. Nestled in one of Phoenix's most desirable neighborhoods, our community provides an excellent location for families prioritizing education and convenience.\n\nPark Paloma features thoughtfully designed one and two-bedroom apartments with amenities like spacious walk-in closets and modern gourmet kitchens. Residents enjoy a vibrant lifestyle with features such as a relaxing spa, a lively clubhouse, and a pet-friendly bark park. Choose Park Paloma for a harmonious blend of community and convenience near Hopi Elementary School in the heart of Maricopa County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Camelback East Village Apts by Hopi Elementary",
      "seo_description": "Discover Park Paloma in Camelback East Village, close to Hopi Elementary School. Ideal family living in Phoenix.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "apartments-near-st-theresa-catholic-school-maricopa-county",
      "search_query": "apartments near St. Theresa Catholic School in Maricopa County",
      "category": "School",
      "h1_title": "Apartments Near St. Theresa Catholic School",
      "h2_subtitle": "Find the perfect home at Park Paloma, just a short distance from St. Theresa Catholic School in Maricopa County. Enjoy community-centered living.",
      "page_copy": "Park Paloma offers prime apartments near St. Theresa Catholic School, perfect for families looking for homes in Maricopa County. Located in the lively Camelback East Village, our community provides a seamless blend of comfort and convenience, ideal for families prioritizing education.\n\nOur one and two-bedroom apartments come with modern features, including gourmet kitchens and ample walk-in closets. The community amenities at Park Paloma are designed to enhance your living experience, featuring a relaxing spa, a vibrant clubhouse, and a welcoming bark park for pets. Enjoy living close to quality educational institutions in a dynamic neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apt Near St. Theresa Catholic School Maricopa",
      "seo_description": "Discover Park Paloma's ideal living near St. Theresa Catholic School in Maricopa County. Family-friendly apartments in Phoenix.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "echo-canyon-school-nearby-park-paloma-apartments",
      "search_query": "Echo Canyon School nearby Park Paloma apartments",
      "category": "School",
      "h1_title": "Echo Canyon School Nearby Park Paloma",
      "h2_subtitle": "Discover Park Paloma, conveniently located near Echo Canyon School. Ideal for families seeking quality education in Phoenix.",
      "page_copy": "Park Paloma is perfectly situated for families looking at apartments near Echo Canyon School. Enjoy living in the vibrant Camelback East Village, just moments away from one of Phoenix's notable schools, which offers excellent educational opportunities within a short commute.\n\nChoose from our well-appointed one and two-bedroom floor plans that feature premium amenities like gourmet kitchens and generous walk-in closets. At Park Paloma, residents can take advantage of community offerings such as a relaxing spa, a lively clubhouse, and an accommodating bark park for pets. Experience the balance of comfort and convenience near Echo Canyon School in beautiful Maricopa County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma Apt near Echo Canyon School",
      "seo_description": "Live at Park Paloma, close to Echo Canyon School in Phoenix. Enjoy family-friendly apartments in the Camelback East Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "apartments-close-to-new-way-academy-phoenix-az",
      "search_query": "apartments close to New Way Academy Phoenix AZ",
      "category": "School",
      "h1_title": "Apartments Close to New Way Academy",
      "h2_subtitle": "Discover Park Paloma, located close to New Way Academy in Phoenix, AZ. Experience accessible and comfortable living today.",
      "page_copy": "If you're in search of apartments close to New Way Academy, Park Paloma offers the ideal location for you. Situated in Camelback East Village, our community provides excellent accessibility to one of Phoenix's well-regarded educational institutions.\n\nPark Paloma features beautifully designed one and two-bedroom apartments, equipped with spacious walk-in closets and gourmet kitchens. Not only will you find comfort in your home, but you'll also enjoy community amenities such as an inviting spa, a vibrant clubhouse, and an on-site bark park. Experience unmatched living convenience just a stone's throw from New Way Academy in Phoenix, AZ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Near New Way Academy: Park Paloma Apartments",
      "seo_description": "Explore Park Paloma apartments near New Way Academy in Phoenix, AZ. Family-friendly living in Camelback East Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "park-paloma-near-gateway-community-college",
      "search_query": "Park Paloma near GateWay Community College",
      "category": "School",
      "h1_title": "Park Paloma Near GateWay Community College",
      "h2_subtitle": "Experience the convenience of living at Park Paloma, located near GateWay Community College. Ideal for students and staff in Phoenix.",
      "page_copy": "Park Paloma presents an exceptional living option for those seeking proximity to GateWay Community College in Phoenix. Nestled within the vibrant Camelback East Village, our community offers easy access for students and faculty alike, making it an ideal choice for academics and professionals.\n\nChoose from our modern one and two-bedroom apartments, designed with features such as gourmet kitchens and expansive walk-in closets. At Park Paloma, you'll discover community-enhancing amenities, including a soothing spa, an energetic clubhouse, and a dedicated bark park. Enhance your educational and professional journey with comfortable and convenient living near GateWay Community College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Close to GateWay Community College",
      "seo_description": "Park Paloma offers ideal living near GateWay Community College in Phoenix. Perfect for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "camelback-east-village-apartments-near-asu-tempe-campus",
      "search_query": "Camelback East Village apartments near Arizona State University Tempe Campus",
      "category": "School",
      "h1_title": "Camelback East Apartments Near ASU",
      "h2_subtitle": "Explore Camelback East Village apartments near Arizona State University Tempe Campus. Perfectly suited for students and staff seeking convenience.",
      "page_copy": "Park Paloma provides an excellent choice for those searching for Camelback East Village apartments near Arizona State University Tempe Campus. Experience the perfect blend of accessibility and comfort, making it convenient for students and faculty yearning for a short commute.\n\nOur community boasts a selection of one and two-bedroom floor plans, all thoughtfully designed with features like gourmet kitchens and spacious walk-in closets. Residents enjoy exclusive amenities such as a relaxing spa, a vibrant clubhouse, and a convenient on-site bark park for pets. Live comfortably while maintaining close proximity to the ASU Tempe Campus in Phoenix.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Camelback East Apts Near ASU Tempe Campus",
      "seo_description": "Discover Park Paloma in Camelback East Village, offering convenience near ASU Tempe Campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "apartments-near-banner-university-medical-center-phoenix",
      "search_query": "apartments near Banner University Medical Center Camelback East Village",
      "category": "Hospital",
      "h1_title": "Apts Near Banner University Medical Center",
      "h2_subtitle": "Find comfort and convenience at Park Paloma, apartments near Banner University Medical Center in Camelback East Village.",
      "page_copy": "Located in the heart of Camelback East Village, Park Paloma is an ideal choice for those seeking apartments near Banner University Medical Center. Our community offers exceptional proximity for medical professionals and patients who desire a convenient commute.\n\nChoose from stylish one and two-bedroom apartments, each featuring gourmet kitchens and spacious walk-in closets. At Park Paloma, residents can also enjoy amenities such as a soothing spa, a lively clubhouse, and an on-site bark park, enhancing your living experience. Experience the blend of comfort and convenience, just moments away from Banner University Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Near Banner Univ Medical Center",
      "seo_description": "Discover Park Paloma apartments near Banner University Medical Center in Camelback East Village, offering ideal living for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "apartments-close-to-mayo-clinic-hospital-phx",
      "search_query": "apartments close to Mayo Clinic Hospital PHX-1 Phoenix AZ",
      "category": "Hospital",
      "h1_title": "Apts Near Mayo Clinic Hospital PHX-1",
      "h2_subtitle": "Discover Park Paloma, offering apartments close to Mayo Clinic Hospital PHX-1 Phoenix, AZ. Ideal for healthcare staff and visitors.",
      "page_copy": "Park Paloma stands as a prime choice for those searching for apartments close to Mayo Clinic Hospital PHX-1 in Phoenix, AZ. Nestled in Camelback East Village, our community provides unmatched convenience for medical professionals and patients seeking nearby accommodations.\n\nExplore our selection of chic one and two-bedroom apartments, designed with modern amenities like gourmet kitchens and spacious walk-in closets. Enhance your lifestyle with our exclusive features, including a relaxing spa, a friendly clubhouse, and an always-ready bark park. Enjoy living in comfort while being just moments from Mayo Clinic Hospital PHX-1.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Close to Mayo Clinic Hospital PHX-1",
      "seo_description": "Choose Park Paloma apartments for convenient living close to Mayo Clinic Hospital PHX-1 in Phoenix.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "apartments-near-pierce-park-phoenix",
      "search_query": "apartments near Pierce Park Phoenix",
      "category": "Park",
      "h1_title": "Apts Near Pierce Park in Phoenix",
      "h2_subtitle": "Discover beautiful apartments near Pierce Park in Phoenix. Park Paloma offers the ideal blend of comfort and location.",
      "page_copy": "Park Paloma offers a perfect living opportunity for those seeking apartments near Pierce Park in Phoenix. Located in the vibrant Camelback East Village, our community caters to individuals and families who appreciate easy access to outdoor spaces and urban conveniences.\n\nChoose from our well-appointed one and two-bedroom floor plans, featuring gourmet kitchens and expansive walk-in closets. Park Paloma residents enjoy a variety of amenities, such as a soothing spa, a dynamic clubhouse, and a pet-friendly bark park. Embrace an enriched living experience while enjoying the proximity to the natural beauty of Pierce Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Near Pierce Park Phoenix Apartments",
      "seo_description": "Live near Pierce Park in Phoenix with Park Paloma's exceptional apartments offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "rentals-close-to-gr-herberger-park-az",
      "search_query": "rentals close to G.R. Herberger Park AZ",
      "category": "Park",
      "h1_title": "Rentals Near G.R. Herberger Park AZ",
      "h2_subtitle": "Discover rentals close to G.R. Herberger Park AZ. Park Paloma offers ideal living with great proximity to outdoor activities.",
      "page_copy": "Set your sights on Park Paloma when searching for rentals close to G.R. Herberger Park in Phoenix, AZ. Nestled in Camelback East Village, our community provides a serene living environment with great access to outdoor recreational spaces and urban amenities.\n\nResidents can choose from stylish one and two-bedroom apartments that feature gourmet kitchens and spacious walk-in closets. Enjoy the luxury of living with top-notch amenities like a spa, a lively clubhouse, and an on-site bark park. Live comfortably in Park Paloma, where nature and convenience reside near G.R. Herberger Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Rentals Near G.R. Herberger Park AZ",
      "seo_description": "Explore Park Paloma rentals close to G.R. Herberger Park in AZ. Enjoy convenient living with great outdoor access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "living-near-kachina-park-camelback-east-village",
      "search_query": "living near Kachina Park in Camelback East Village",
      "category": "Park",
      "h1_title": "Live Near Kachina Park, Camelback East",
      "h2_subtitle": "Experience living near Kachina Park in Camelback East Village. Park Paloma offers comfort and convenience in an ideal location.",
      "page_copy": "Experience the joys of living near Kachina Park in Camelback East Village at Park Paloma. Our community sits comfortably in the heart of Phoenix, offering residents the perfect blend of urban amenities and natural beauty.\n\nChoose from our thoughtfully designed one and two-bedroom floor plans, each offering gourmet kitchens and generous walk-in closets. With amenities like a tranquil spa, a bustling clubhouse, and a pet-friendly bark park on-site, Park Paloma caters to a modern lifestyle. Enjoy the vibrant community and proximity to Kachina Park for a truly enriching living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Near Kachina Park, Camelback East",
      "seo_description": "Park Paloma offers comfortable living near Kachina Park in Camelback East Village, Phoenix.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "arcadia-park-area-apartments",
      "search_query": "Arcadia Park area apartments",
      "category": "Park",
      "h1_title": "Arcadia Park Area Apartments",
      "h2_subtitle": "Explore Arcadia Park area apartments for a comfortable lifestyle. Discover Park Paloma in Camelback East Village.",
      "page_copy": "If you're searching for Arcadia Park area apartments, look no further than Park Paloma. Nestled in the vibrant Camelback East Village, our community presents an ideal location for those who cherish convenience and community closeness.\n\nPark Paloma features elegantly designed one and two-bedroom apartments with gourmet kitchens and spacious walk-in closets. Enjoy inviting amenities like a relaxing spa, a lively clubhouse, and an on-site bark park, enhancing your living experience. With close proximity to Arcadia Park, you'll find Park Paloma provides both style and accessibility in a sought-after Phoenix neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Arcadia Park Area Apartments",
      "seo_description": "Discover charming apartments in the Arcadia Park area at Park Paloma, offering a perfect blend of comfort and location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "desert-botanical-garden-rentals",
      "search_query": "nearby Desert Botanical Garden rentals",
      "category": "Park",
      "h1_title": "Rentals Near Desert Botanical Garden",
      "h2_subtitle": "Search for nearby Desert Botanical Garden rentals at Park Paloma. Enjoy easy accessibility and superb amenities.",
      "page_copy": "Discover the ideal blend of comfort and natural beauty with rentals nearby the Desert Botanical Garden at Park Paloma. Located in the heart of Camelback East Village, Phoenix, our community offers picturesque living spaces close to one of the city's most enchanting attractions.\n\nChoose from our refined one and two-bedroom apartments designed with gourmet kitchens and ample walk-in closets. Enjoy exclusive amenities like a rejuvenating spa and a vibrant clubhouse. With a pet-friendly bark park on-site, Park Paloma ensures a harmonious lifestyle, conveniently close to the Desert Botanical Garden and urban conveniences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Rentals Near Desert Botanical Garden",
      "seo_description": "Find rentals nearby Desert Botanical Garden at Park Paloma, where style meets convenience in Camelback East Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "maricopa-county-apartments-steele-indian-school-park",
      "search_query": "Maricopa County apartments near Steele Indian School Park",
      "category": "Park",
      "h1_title": "Apartments Near Steele Indian School Park",
      "h2_subtitle": "Discover Maricopa County apartments near Steele Indian School Park at Park Paloma. Enjoy comfortable living in a vibrant community.",
      "page_copy": "Explore luxurious living in Maricopa County with apartments near Steele Indian School Park at Park Paloma. Situated in the dynamic Camelback East Village, our community provides a perfect location for convenience and leisure.\n\nOffering thoughtfully designed one and two-bedroom floor plans, each apartment includes gourmet kitchens and expansive walk-in closets. Our amenities, including a soothing spa, engaging clubhouse, and an on-site bark park, enhance your living experience. With close access to Steele Indian School Park, Park Paloma offers a harmonious blend of comfort, accessibility, and community spirit, making it an ideal choice for your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Apartments Near Steele Indian School Park",
      "seo_description": "Find Maricopa County apartments near Steele Indian School Park at Park Paloma, combining comfort and accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "apartments-near-44th-st-washington-phoenix",
      "search_query": "apartments near 44th St/Washington Phoenix",
      "category": "Transit",
      "h1_title": "Apartments Near 44th St/Washington",
      "h2_subtitle": "Explore apartments near 44th St/Washington in Phoenix. Park Paloma offers stylish living in a prime location.",
      "page_copy": "Discover exquisite apartments near 44th St/Washington Phoenix at Park Paloma. Located in the heart of Camelback East Village, our community provides easy access to downtown and major transit routes.\n\nChoose from our beautifully designed one and two-bedroom apartments, each featuring gourmet kitchens and spacious walk-in closets. Enjoy our exclusive amenities, such as a serene spa, lively clubhouse, and a pet-friendly bark park. Living at Park Paloma means you're just minutes away from the vibrant intersection of 44th St and Washington, offering loads of shopping, dining, and entertainment options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Apartments Near 44th St/Washington",
      "seo_description": "Find stylish apartments near 44th St/Washington in Phoenix at Park Paloma, offering convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "rentals-close-to-44th-st-station-camelback-east-village",
      "search_query": "rentals close to 44th St Station Camelback East Village",
      "category": "Transit",
      "h1_title": "Rentals Near 44th St Station",
      "h2_subtitle": "Find rentals close to 44th St Station in Camelback East Village. Experience convenience and modern amenities at Park Paloma.",
      "page_copy": "Discover the convenience of living with rentals close to 44th St Station in the vibrant Camelback East Village at Park Paloma. Our location ensures seamless connectivity across Phoenix while providing a tranquil retreat from urban bustle.\n\nSelect from our range of one and two-bedroom apartments, thoughtfully designed with features like gourmet kitchens and roomy walk-in closets. Enjoy top-tier amenities such as a relaxing spa, an energetic clubhouse, and a pet-friendly bark park. With easy access to the 44th St Station and the vibrant community surrounding it, Park Paloma is the perfect balance of connectivity and lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Rentals Near 44th St Station",
      "seo_description": "Enjoy rentals close to 44th St Station in Camelback East Village at Park Paloma, where convenience meets comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "apartments-near-indian-school-central-ave-phoenix",
      "search_query": "apartments near Indian School/Central Ave Phoenix",
      "category": "Transit",
      "h1_title": "Apartments Near Indian School/Central Ave",
      "h2_subtitle": "Discover apartments near Indian School/Central Ave in Phoenix. Park Paloma offers a vibrant lifestyle with modern living and amenities.",
      "page_copy": "Explore the dynamic lifestyle with apartments near Indian School/Central Ave Phoenix at Park Paloma. Located in the Camelback East Village, our community provides easy access to all the attractions and conveniences of central Phoenix.\n\nOur one and two-bedroom apartments feature gourmet kitchens and generous walk-in closets, designed to cater to your living needs. Relax in our spa, socialize in the bustling clubhouse, or visit the on-site bark park with your furry friends. Staying at Park Paloma means you are never far from the cultural and culinary buzz that Indian School and Central Ave offer, making it a perfect choice for your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Apts Near Indian School/Central Ave",
      "seo_description": "Discover Park Paloma, offering beautiful apartments near Indian School/Central Ave Phoenix, with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "rentals-by-38th-st-washington-maricopa-county",
      "search_query": "rentals by 38th St/Washington Maricopa County",
      "category": "Transit",
      "h1_title": "Rentals By 38th St/Washington",
      "h2_subtitle": "Find rentals by 38th St/Washington in Maricopa County. Park Paloma offers upscale living with unmatched amenities.",
      "page_copy": "Discover sophisticated rentals by 38th St/Washington in Maricopa County at Park Paloma. Nestled in the vibrant Camelback East Village, our community offers prime access to Phoenix's bustling downtown and beyond.\n\nOur community presents expertly crafted one and two-bedroom floor plans featuring gourmet kitchens and expansive walk-in closets. Indulge in our exclusive amenities, including a tranquil spa, lively clubhouse, and a pet-friendly bark park. Living at Park Paloma means you're conveniently near the intersecting charms of 38th St and Washington, with ample opportunities for shopping, dining, and entertainment right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Rentals Near 38th St/Washington",
      "seo_description": "Enjoy rentals by 38th St/Washington in Maricopa County at Park Paloma, offering upscale living and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166801",
      "source": "generator",
      "page_item_url": "apartments-near-phoenix-sky-harbor-airport",
      "search_query": "apartments near Phoenix Sky Harbor International Airport AZ",
      "category": "Transit",
      "h1_title": "Apartments Near Phoenix Sky Harbor Airport",
      "h2_subtitle": "Explore apartments near Phoenix Sky Harbor International Airport, AZ. Park Paloma combines convenience with modern amenities.",
      "page_copy": "Enjoy the perfect blend of convenience and comfort with apartments near Phoenix Sky Harbor International Airport, AZ at Park Paloma. Located in the charming Camelback East Village, our community offers easy access to air travel and the vibrant heart of Phoenix.\n\nOur spacious one and two-bedroom apartments are thoughtfully designed with features like gourmet kitchens and impressive walk-in closets. Revel in our exclusive amenities, including a relaxing spa, active clubhouse, and even a bark park for your pets. Park Paloma ensures that you'll enjoy modern living while being just a short distance from the airport, making it ideal for frequent travelers and city explorers alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
      "featured_image_media": {
        "alt_text": "Park Paloma Apartment Homes sign and building exterior.",
        "public_id": "019d02d0-dd22-766e-9898-cde248f4cfd8",
        "storage_key": "property/6767906449166801/019d02d0-dd22-766e-9898-cde248f4cfd8.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Paloma: Apts Near Phoenix Sky Harbor Airport",
      "seo_description": "Find Park Paloma apartments near Phoenix Sky Harbor Airport, AZ, offering modern comfort and easy airport access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "lindseye@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5589"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10715005594"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TW74433S"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "234PAP"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('J4A2FEaGwNT6clb0TF')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "41632009012"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rkwn19yzpd2"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Park Paloma/scheduletourwidget/y5HpcnYAuBJSoiau19/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik85Q2dXNGNKR1AyUUZBeEpyVm9ZRWc9PSIsInZhbHVlIjoiTHMvSDg3YzJCdlp3NGkxT2hINkR0Zz09IiwibWFjIjoiMThmNDk4MzAxNDY3ZmVlYjk3YzE3YjAxOWRlZDUzMWQzOWViNTIwYzk2NWQ2OGNmZmZiNmZlYzNkZTk5MGQyNCJ9"
    }
  ],
  "custom_csm": "lindseye@repli360.com",
  "custom_qb_id": "5589",
  "custom_repli_id": "10715005594",
  "custom_google_gtm_id": "GTM-TW74433S",
  "custom_rollout_phase": "Pathfinder 3",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "none",
  "custom_aim_property_code": "234PAP",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('J4A2FEaGwNT6clb0TF')</script>",
  "custom_hubspot_company_id": "41632009012",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/rkwn19yzpd2",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Park Paloma/scheduletourwidget/y5HpcnYAuBJSoiau19/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik85Q2dXNGNKR1AyUUZBeEpyVm9ZRWc9PSIsInZhbHVlIjoiTHMvSDg3YzJCdlp3NGkxT2hINkR0Zz09IiwibWFjIjoiMThmNDk4MzAxNDY3ZmVlYjk3YzE3YjAxOWRlZDUzMWQzOWViNTIwYzk2NWQ2OGNmZmZiNmZlYzNkZTk5MGQyNCJ9",
  "custom_audioeye_site_id": "77996cbb-dc03-45f5-9d60-3412d2845e00",
  "custom_audioeye_site_hash": "f994c6f635880ebcf992ffb47c62cab0"
};

export const generatedAt = '2026-10-08T20:10:21.856Z';
